/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface IClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditHeaderByFilter(body: GetAllAuditHeaderByFilterModel | undefined): Promise<GetAllAuditHeaderByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAuditById(body: GetAuditByIdQueryRequest | undefined): Promise<GetAuditByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserLoginReportData(body: GetUserLoginReportDataQueryRequest | undefined): Promise<GetUserLoginReportDataQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditTypes(body: GetAllAuditTypesQueryRequest | undefined): Promise<GetAllAuditTypesQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addCategory(body: AddCategoryCommandRequest | undefined): Promise<KnowledgeCategory>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editCategory(body: EditCategoryCommandRequest | undefined): Promise<void>;
    removeCategory(body: RemoveCategoryCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCategoryById(body: GetCategoryByIdQueryRequest | undefined): Promise<GetCategoryByIdQueryResponse>;
    addComment(body: AddCommentCommandRequest | undefined): Promise<void>;
    editComment(body: EditCommentCommandRequest | undefined): Promise<void>;
    deleteComment(body: DeleteCommentCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCommentsForKnowledgeByFilterQuery(body: GetAllCommentsForKnowledgeByFilterQueryRequest | undefined): Promise<GetAllCommentsForKnowledgeByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: Blob | undefined): Promise<string>;
    /**
     * @return Success
     */
    import2(id: string): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    spellCheck(body: SpellCheckJsonData | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    spellCheckByPage(body: SpellCheckJsonData | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    systemClipboard(body: CustomParameter | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    restrictEditing(body: CustomRestrictParameter | undefined): Promise<string[]>;
    /**
     * @return Success
     */
    loadDefault(): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: Blob | undefined): Promise<void>;
    addDocument(body: AddDocumentModel | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addDocumentsToKnowledge(body: Blob | undefined): Promise<DocumentModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDocument(body: DeleteDocumentCommandRequest | undefined): Promise<DocumentModel[]>;
    /**
     * @return Success
     */
    file(id: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @return Success
     */
    file2(id: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addJurisdiction(body: AddJurisdictionCommandRequest | undefined): Promise<Jurisdiction>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeJurisdiction(body: RemoveJurisdictionCommandRequest | undefined): Promise<RemoveJurisdictionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editJurisdiction(body: EditJurisdictionCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getJurisdictionById(body: GetJurisdictionByIdQueryRequest | undefined): Promise<GetJurisdictionByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createKnowledgeDataTemplate(body: CreateKnowledgeDataTemplateCommandRequest | undefined): Promise<KnowledgeDataTemplate>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteKnowledgeDataTemplate(body: DeleteKnowledgeDataTemplateCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editKnowledgeDataTemplate(body: EditKnowledgeDataTemplateCommandRequest | undefined): Promise<KnowledgeDataTemplate>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeDataTemplateByFilter(body: GetAllKnowledgeDataTemplatesByFilterQueryRequest | undefined): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeDataTemplateForPublicByFilter(body: GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest | undefined): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeDataTemplateById(body: GetKnowledgeDataTemplateByIdCommandRequest | undefined): Promise<KnowledgeDataTemplate>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addKnowledge(body: Blob | undefined): Promise<Knowledge>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editKnowledge(body: EditKnowledgeCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteKnowledge(body: DeleteKnowledgeCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeByFilter(body: GetAllKnowledgeByFilterQueryRequest | undefined): Promise<GetAllKnowledgeByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeSummaryReportData(body: GetKnowledgeSummaryReportDataQueryRequest | undefined): Promise<GetKnowledgeSummaryReportDataQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeFileReportData(body: GetKnowledgeFileReportDataQueryRequest | undefined): Promise<GetKnowledgeFileReportDataQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPublicKnowledgeByFilter(body: GetAllPublicKnowledgeByFilterQueryRequest | undefined): Promise<GetAllPublicKnowledgeByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeById(body: GetKnowledgeByIdQueryRequest | undefined): Promise<GetKnowledgeByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeByName(body: GetKnowledgeByNameQueryRequest | undefined): Promise<GetKnowledgeByNameQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeContributorReportData(body: GetKnowledgeContributorReportDataQueryRequest | undefined): Promise<GetKnowledgeContributorReportDataQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeKnowledgeStatus(body: ChangeKnowledgeStatusCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    canUserAccessKnowledge(body: CanUserAccessKnowledgeQueryRequest | undefined): Promise<CanUserAccessKnowledgeQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    load(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    bookmarks(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfPages(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    renderThumbnailImages(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    renderAnnotationComments(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    exportAnnotations(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    importAnnotations(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    unload(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    printImages(body: { [key: string]: string; } | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    postReportAction(body: { [key: string]: any; } | undefined): Promise<void>;
    /**
     * @param key (optional) 
     * @param resourcetype (optional) 
     * @param isPrint (optional) 
     * @return Success
     */
    getResource(key: string | undefined, resourcetype: string | undefined, isPrint: boolean | undefined): Promise<void>;
    /**
     * @return Success
     */
    postFormReportAction(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addRole(body: AddRoleCommandRequest | undefined): Promise<AddRoleCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editRole(body: EditRoleCommandRequest | undefined): Promise<EditRoleCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeRole(body: RemoveRoleCommandRequest | undefined): Promise<RemoveRoleCommandResponse>;
    /**
     * @return Success
     */
    getOperations(): Promise<GetOperationsListCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRolesByFilter(body: GetAllRolesByFilterQueryRequest | undefined): Promise<GetAllRolesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getRoleById(body: GetRoleByIdQueryRequest | undefined): Promise<GetRoleByIdQueryResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: UnlockUserCommandRequest | undefined): Promise<UnlockUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    activateUser(body: ActivateUserCommandRequest | undefined): Promise<ActivateUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredCountries(body: GetFilteredCountriesQueryRequest | undefined): Promise<GetFilteredCountriesQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredJurisdictions(body: GetFilteredJurisdictionsQueryRequest | undefined): Promise<GetFilteredJurisdictionsQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCategoryByFilter(body: GetAllCategoryByFilterQueryRequest | undefined): Promise<GetAllCategoryByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserKnowledgeShareRequestByFilter(body: GetAllUserKnowledgeShareRequestByFilterQueryRequest | undefined): Promise<GetAllUserKnowledgeShareRequestByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserSharedKnowledgeRequestById(body: GetUserSharedKnowledgeRequestByIdCommandRequest | undefined): Promise<GetUserSharedKnowledgeRequestByIdCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addSharedKnowledgeRequest(body: AddKnowledgeShareCommandRequest | undefined): Promise<AddKnowledgeShareCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveKnowledgeShare(body: ApproveKnowledgeShareCommandRequest | undefined): Promise<ApproveKnowledgeShareCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rejectKnowledgeShare(body: RejectKnowledgeShareCommandRequest | undefined): Promise<RejectKnowledgeShareCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllSharedKnowledgeByFilter(body: GetAllSharedKnowledgeByFilterQueryRequest | undefined): Promise<GetAllSharedKnowledgeByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersByFilter(body: GetAllUsersByFilterQueryRequest | undefined): Promise<GetAllUsersByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserRegistrationByFilter(body: GetAllUserRegistrationByFilterQueryRequest | undefined): Promise<GetAllUserRegistrationByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersReportData(body: GetAllUsersReportDataQueryRequest | undefined): Promise<GetAllUsersReportDataQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserById(body: GetUserByIdQueryRequest | undefined): Promise<GetUserByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserRegistrationById(body: GetUserRegistrationByIdQueryRequest | undefined): Promise<GetUserRegistrationByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveUserRegistrationById(body: ApproveUserRegistrationCommandRequest | undefined): Promise<ApproveUserRegistrationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rejectUserRegistrationById(body: RejectUserRegistrationCommandRequest | undefined): Promise<RejectUserRegistrationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserStatus(body: ChangeUserStatusCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: EditUserCommandRequest | undefined): Promise<EditUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerUser(body: RegisterUserCommandRequest | undefined): Promise<RegisterUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resendConfirmationEmail(body: ResendConfirmationEmailCommandRequest | undefined): Promise<ResendConfirmationEmailCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeUser(body: RemoveUserCommandRequest | undefined): Promise<RemoveUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: AddUserCommandRequest | undefined): Promise<AddUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserInfoForPublicByFilter(body: GetAllUserInfoForPublicByFilterQueryRequest | undefined): Promise<GetAllUserInfoForPublicByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRoleInfosForPublicByFilter(body: GetAllRoleInfosForPublicByFilterQueryRequest | undefined): Promise<GetAllRoleInfosForPublicByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    generateUsersCsv(body: GenerateEnabledUsersCsvCommandRequest | undefined): Promise<GenerateEnabledUsersCsvCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    generateUsersCsv2(body: GenerateEnabledUsersCsvCommandRequest | undefined): Promise<GenerateEnabledUsersCsvCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserPreference(body: GetUserPreferenceCommandRequest | undefined): Promise<GetUserPreferenceCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upsertUserPreference(body: UpsertUserPreferenceCommandRequest | undefined): Promise<UpsertUserPreferenceCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    pinKnowledge(body: PinKnowledgeCommandRequest | undefined): Promise<PinKnowledgeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    unPinKnowledge(body: UnPinKnowledgeCommandRequest | undefined): Promise<UnPinKnowledgeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMyRecentKnowledgeByFilter(body: GetMyRecentKnowledgeByFilterQueryRequest | undefined): Promise<GetMyRecentKnowledgeByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMyPinnedKnowledgeByFilter(body: GetMyPinnedKnowledgesByFilterQueryRequest | undefined): Promise<GetMyPinnedKnowledgesByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    getMyUserProfile(): Promise<GetMyUserProfileQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUserProfile(body: GetUserProfileQueryRequest | undefined): Promise<GetUserProfileQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: EditUserProfileCommandRequest | undefined): Promise<EditUserProfileCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserProfileByFilter(body: GetAllUserProfileByFilterQueryRequest | undefined): Promise<GetAllUserProfileByFilterQueryResponse>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditHeaderByFilter(body: GetAllAuditHeaderByFilterModel | undefined): Promise<GetAllAuditHeaderByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetAllAuditHeaderByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllAuditHeaderByFilter(_response);
        });
    }

    protected processGetAllAuditHeaderByFilter(response: AxiosResponse): Promise<GetAllAuditHeaderByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAuditHeaderByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAuditHeaderByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuditById(body: GetAuditByIdQueryRequest | undefined): Promise<GetAuditByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetAuditById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuditById(_response);
        });
    }

    protected processGetAuditById(response: AxiosResponse): Promise<GetAuditByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuditByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserLoginReportData(body: GetUserLoginReportDataQueryRequest | undefined): Promise<GetUserLoginReportDataQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetUserLoginReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserLoginReportData(_response);
        });
    }

    protected processGetUserLoginReportData(response: AxiosResponse): Promise<GetUserLoginReportDataQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserLoginReportDataQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserLoginReportDataQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAuditTypes(body: GetAllAuditTypesQueryRequest | undefined): Promise<GetAllAuditTypesQueryResponse> {
        let url_ = this.baseUrl + "/api/AuditManagement/GetAllAuditTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllAuditTypes(_response);
        });
    }

    protected processGetAllAuditTypes(response: AxiosResponse): Promise<GetAllAuditTypesQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAuditTypesQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAuditTypesQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCategory(body: AddCategoryCommandRequest | undefined): Promise<KnowledgeCategory> {
        let url_ = this.baseUrl + "/api/CategoryManagement/AddCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddCategory(_response);
        });
    }

    protected processAddCategory(response: AxiosResponse): Promise<KnowledgeCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeCategory.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeCategory>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCategory(body: EditCategoryCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CategoryManagement/EditCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditCategory(_response);
        });
    }

    protected processEditCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    removeCategory(body: RemoveCategoryCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CategoryManagement/RemoveCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveCategory(_response);
        });
    }

    protected processRemoveCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCategoryById(body: GetCategoryByIdQueryRequest | undefined): Promise<GetCategoryByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/CategoryManagement/GetCategoryById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCategoryById(_response);
        });
    }

    protected processGetCategoryById(response: AxiosResponse): Promise<GetCategoryByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCategoryByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCategoryByIdQueryResponse>(<any>null);
    }

    addComment(body: AddCommentCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CommentsManagement/AddComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddComment(_response);
        });
    }

    protected processAddComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    editComment(body: EditCommentCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CommentsManagement/EditComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditComment(_response);
        });
    }

    protected processEditComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteComment(body: DeleteCommentCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CommentsManagement/DeleteComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCommentsForKnowledgeByFilterQuery(body: GetAllCommentsForKnowledgeByFilterQueryRequest | undefined): Promise<GetAllCommentsForKnowledgeByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/CommentsManagement/GetAllCommentsForKnowledgeByFilterQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllCommentsForKnowledgeByFilterQuery(_response);
        });
    }

    protected processGetAllCommentsForKnowledgeByFilterQuery(response: AxiosResponse): Promise<GetAllCommentsForKnowledgeByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllCommentsForKnowledgeByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllCommentsForKnowledgeByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: Blob | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    import2(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/Import/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImport2(_response);
        });
    }

    protected processImport2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    spellCheck(body: SpellCheckJsonData | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/SpellCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSpellCheck(_response);
        });
    }

    protected processSpellCheck(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    spellCheckByPage(body: SpellCheckJsonData | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/SpellCheckByPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSpellCheckByPage(_response);
        });
    }

    protected processSpellCheckByPage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    systemClipboard(body: CustomParameter | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/SystemClipboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSystemClipboard(_response);
        });
    }

    protected processSystemClipboard(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restrictEditing(body: CustomRestrictParameter | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DocumentEditor/RestrictEditing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestrictEditing(_response);
        });
    }

    protected processRestrictEditing(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    loadDefault(): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentEditor/LoadDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoadDefault(_response);
        });
    }

    protected processLoadDefault(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: Blob | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentEditor/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    addDocument(body: AddDocumentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentManagement/AddDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddDocument(_response);
        });
    }

    protected processAddDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocumentsToKnowledge(body: Blob | undefined): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/DocumentManagement/AddDocumentsToKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddDocumentsToKnowledge(_response);
        });
    }

    protected processAddDocumentsToKnowledge(response: AxiosResponse): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDocument(body: DeleteDocumentCommandRequest | undefined): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/DocumentManagement/DeleteDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    file(id: string): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    file2(id: string): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFile2(_response);
        });
    }

    protected processFile2(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addJurisdiction(body: AddJurisdictionCommandRequest | undefined): Promise<Jurisdiction> {
        let url_ = this.baseUrl + "/api/JurisdictionManagement/AddJurisdiction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddJurisdiction(_response);
        });
    }

    protected processAddJurisdiction(response: AxiosResponse): Promise<Jurisdiction> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Jurisdiction.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Jurisdiction>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeJurisdiction(body: RemoveJurisdictionCommandRequest | undefined): Promise<RemoveJurisdictionCommandResponse> {
        let url_ = this.baseUrl + "/api/JurisdictionManagement/RemoveJurisdiction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveJurisdiction(_response);
        });
    }

    protected processRemoveJurisdiction(response: AxiosResponse): Promise<RemoveJurisdictionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveJurisdictionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveJurisdictionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editJurisdiction(body: EditJurisdictionCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JurisdictionManagement/EditJurisdiction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditJurisdiction(_response);
        });
    }

    protected processEditJurisdiction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJurisdictionById(body: GetJurisdictionByIdQueryRequest | undefined): Promise<GetJurisdictionByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/JurisdictionManagement/GetJurisdictionById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetJurisdictionById(_response);
        });
    }

    protected processGetJurisdictionById(response: AxiosResponse): Promise<GetJurisdictionByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJurisdictionByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJurisdictionByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createKnowledgeDataTemplate(body: CreateKnowledgeDataTemplateCommandRequest | undefined): Promise<KnowledgeDataTemplate> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/CreateKnowledgeDataTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateKnowledgeDataTemplate(_response);
        });
    }

    protected processCreateKnowledgeDataTemplate(response: AxiosResponse): Promise<KnowledgeDataTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeDataTemplate.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeDataTemplate>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteKnowledgeDataTemplate(body: DeleteKnowledgeDataTemplateCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/DeleteKnowledgeDataTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteKnowledgeDataTemplate(_response);
        });
    }

    protected processDeleteKnowledgeDataTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editKnowledgeDataTemplate(body: EditKnowledgeDataTemplateCommandRequest | undefined): Promise<KnowledgeDataTemplate> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/EditKnowledgeDataTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditKnowledgeDataTemplate(_response);
        });
    }

    protected processEditKnowledgeDataTemplate(response: AxiosResponse): Promise<KnowledgeDataTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeDataTemplate.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeDataTemplate>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeDataTemplateByFilter(body: GetAllKnowledgeDataTemplatesByFilterQueryRequest | undefined): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/GetAllKnowledgeDataTemplateByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllKnowledgeDataTemplateByFilter(_response);
        });
    }

    protected processGetAllKnowledgeDataTemplateByFilter(response: AxiosResponse): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllKnowledgeDataTemplatesByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllKnowledgeDataTemplatesByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeDataTemplateForPublicByFilter(body: GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest | undefined): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/GetAllKnowledgeDataTemplateForPublicByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllKnowledgeDataTemplateForPublicByFilter(_response);
        });
    }

    protected processGetAllKnowledgeDataTemplateForPublicByFilter(response: AxiosResponse): Promise<GetAllKnowledgeDataTemplatesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllKnowledgeDataTemplatesByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllKnowledgeDataTemplatesByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeDataTemplateById(body: GetKnowledgeDataTemplateByIdCommandRequest | undefined): Promise<KnowledgeDataTemplate> {
        let url_ = this.baseUrl + "/api/KnowledgeDataTemplateManagement/GetKnowledgeDataTemplateById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeDataTemplateById(_response);
        });
    }

    protected processGetKnowledgeDataTemplateById(response: AxiosResponse): Promise<KnowledgeDataTemplate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeDataTemplate.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeDataTemplate>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addKnowledge(body: Blob | undefined): Promise<Knowledge> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/AddKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddKnowledge(_response);
        });
    }

    protected processAddKnowledge(response: AxiosResponse): Promise<Knowledge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Knowledge.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Knowledge>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editKnowledge(body: EditKnowledgeCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/EditKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditKnowledge(_response);
        });
    }

    protected processEditKnowledge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteKnowledge(body: DeleteKnowledgeCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/DeleteKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteKnowledge(_response);
        });
    }

    protected processDeleteKnowledge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllKnowledgeByFilter(body: GetAllKnowledgeByFilterQueryRequest | undefined): Promise<GetAllKnowledgeByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetAllKnowledgeByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllKnowledgeByFilter(_response);
        });
    }

    protected processGetAllKnowledgeByFilter(response: AxiosResponse): Promise<GetAllKnowledgeByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllKnowledgeByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllKnowledgeByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeSummaryReportData(body: GetKnowledgeSummaryReportDataQueryRequest | undefined): Promise<GetKnowledgeSummaryReportDataQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetKnowledgeSummaryReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeSummaryReportData(_response);
        });
    }

    protected processGetKnowledgeSummaryReportData(response: AxiosResponse): Promise<GetKnowledgeSummaryReportDataQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKnowledgeSummaryReportDataQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKnowledgeSummaryReportDataQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeFileReportData(body: GetKnowledgeFileReportDataQueryRequest | undefined): Promise<GetKnowledgeFileReportDataQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetKnowledgeFileReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeFileReportData(_response);
        });
    }

    protected processGetKnowledgeFileReportData(response: AxiosResponse): Promise<GetKnowledgeFileReportDataQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKnowledgeFileReportDataQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKnowledgeFileReportDataQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPublicKnowledgeByFilter(body: GetAllPublicKnowledgeByFilterQueryRequest | undefined): Promise<GetAllPublicKnowledgeByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetAllPublicKnowledgeByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllPublicKnowledgeByFilter(_response);
        });
    }

    protected processGetAllPublicKnowledgeByFilter(response: AxiosResponse): Promise<GetAllPublicKnowledgeByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPublicKnowledgeByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPublicKnowledgeByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeById(body: GetKnowledgeByIdQueryRequest | undefined): Promise<GetKnowledgeByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetKnowledgeById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeById(_response);
        });
    }

    protected processGetKnowledgeById(response: AxiosResponse): Promise<GetKnowledgeByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKnowledgeByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKnowledgeByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeByName(body: GetKnowledgeByNameQueryRequest | undefined): Promise<GetKnowledgeByNameQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetKnowledgeByName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeByName(_response);
        });
    }

    protected processGetKnowledgeByName(response: AxiosResponse): Promise<GetKnowledgeByNameQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKnowledgeByNameQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKnowledgeByNameQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getKnowledgeContributorReportData(body: GetKnowledgeContributorReportDataQueryRequest | undefined): Promise<GetKnowledgeContributorReportDataQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/GetKnowledgeContributorReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeContributorReportData(_response);
        });
    }

    protected processGetKnowledgeContributorReportData(response: AxiosResponse): Promise<GetKnowledgeContributorReportDataQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKnowledgeContributorReportDataQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKnowledgeContributorReportDataQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeKnowledgeStatus(body: ChangeKnowledgeStatusCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/ChangeKnowledgeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeKnowledgeStatus(_response);
        });
    }

    protected processChangeKnowledgeStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    canUserAccessKnowledge(body: CanUserAccessKnowledgeQueryRequest | undefined): Promise<CanUserAccessKnowledgeQueryResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeManagement/CanUserAccessKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCanUserAccessKnowledge(_response);
        });
    }

    protected processCanUserAccessKnowledge(response: AxiosResponse): Promise<CanUserAccessKnowledgeQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CanUserAccessKnowledgeQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CanUserAccessKnowledgeQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    load(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/Load";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoad(_response);
        });
    }

    protected processLoad(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bookmarks(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBookmarks(_response);
        });
    }

    protected processBookmarks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfPages(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/RenderPdfPages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderPdfPages(_response);
        });
    }

    protected processRenderPdfPages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderThumbnailImages(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/RenderThumbnailImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderThumbnailImages(_response);
        });
    }

    protected processRenderThumbnailImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderAnnotationComments(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/RenderAnnotationComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAnnotationComments(_response);
        });
    }

    protected processRenderAnnotationComments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAnnotations(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/ExportAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportAnnotations(_response);
        });
    }

    protected processExportAnnotations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importAnnotations(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/ImportAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportAnnotations(_response);
        });
    }

    protected processImportAnnotations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unload(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/Unload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnload(_response);
        });
    }

    protected processUnload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printImages(body: { [key: string]: string; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfViewer/PrintImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPrintImages(_response);
        });
    }

    protected processPrintImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postReportAction(body: { [key: string]: any; } | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportViewer/PostReportAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPostReportAction(_response);
        });
    }

    protected processPostReportAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param key (optional) 
     * @param resourcetype (optional) 
     * @param isPrint (optional) 
     * @return Success
     */
    getResource(key: string | undefined, resourcetype: string | undefined, isPrint: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportViewer/GetResource?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        if (resourcetype === null)
            throw new Error("The parameter 'resourcetype' cannot be null.");
        else if (resourcetype !== undefined)
            url_ += "resourcetype=" + encodeURIComponent("" + resourcetype) + "&"; 
        if (isPrint === null)
            throw new Error("The parameter 'isPrint' cannot be null.");
        else if (isPrint !== undefined)
            url_ += "isPrint=" + encodeURIComponent("" + isPrint) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetResource(_response);
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    postFormReportAction(): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportViewer/PostFormReportAction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPostFormReportAction(_response);
        });
    }

    protected processPostFormReportAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRole(body: AddRoleCommandRequest | undefined): Promise<AddRoleCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/AddRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddRole(_response);
        });
    }

    protected processAddRole(response: AxiosResponse): Promise<AddRoleCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRoleCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRoleCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editRole(body: EditRoleCommandRequest | undefined): Promise<EditRoleCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/EditRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditRole(_response);
        });
    }

    protected processEditRole(response: AxiosResponse): Promise<EditRoleCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditRoleCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditRoleCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeRole(body: RemoveRoleCommandRequest | undefined): Promise<RemoveRoleCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/RemoveRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveRole(_response);
        });
    }

    protected processRemoveRole(response: AxiosResponse): Promise<RemoveRoleCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveRoleCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveRoleCommandResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getOperations(): Promise<GetOperationsListCommandResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetOperations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOperations(_response);
        });
    }

    protected processGetOperations(response: AxiosResponse): Promise<GetOperationsListCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOperationsListCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOperationsListCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRolesByFilter(body: GetAllRolesByFilterQueryRequest | undefined): Promise<GetAllRolesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetAllRolesByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllRolesByFilter(_response);
        });
    }

    protected processGetAllRolesByFilter(response: AxiosResponse): Promise<GetAllRolesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRolesByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRolesByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoleById(body: GetRoleByIdQueryRequest | undefined): Promise<GetRoleByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/RoleManagement/GetRoleById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRoleById(_response);
        });
    }

    protected processGetRoleById(response: AxiosResponse): Promise<GetRoleByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleByIdQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: UnlockUserCommandRequest | undefined): Promise<UnlockUserCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnlockUser(_response);
        });
    }

    protected processUnlockUser(response: AxiosResponse): Promise<UnlockUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnlockUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnlockUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateUser(body: ActivateUserCommandRequest | undefined): Promise<ActivateUserCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/ActivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: AxiosResponse): Promise<ActivateUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivateUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivateUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredCountries(body: GetFilteredCountriesQueryRequest | undefined): Promise<GetFilteredCountriesQueryResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetFilteredCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFilteredCountries(_response);
        });
    }

    protected processGetFilteredCountries(response: AxiosResponse): Promise<GetFilteredCountriesQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredCountriesQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredCountriesQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredJurisdictions(body: GetFilteredJurisdictionsQueryRequest | undefined): Promise<GetFilteredJurisdictionsQueryResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetFilteredJurisdictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFilteredJurisdictions(_response);
        });
    }

    protected processGetFilteredJurisdictions(response: AxiosResponse): Promise<GetFilteredJurisdictionsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredJurisdictionsQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredJurisdictionsQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCategoryByFilter(body: GetAllCategoryByFilterQueryRequest | undefined): Promise<GetAllCategoryByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetAllCategoryByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllCategoryByFilter(_response);
        });
    }

    protected processGetAllCategoryByFilter(response: AxiosResponse): Promise<GetAllCategoryByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllCategoryByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllCategoryByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserKnowledgeShareRequestByFilter(body: GetAllUserKnowledgeShareRequestByFilterQueryRequest | undefined): Promise<GetAllUserKnowledgeShareRequestByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/GetAllUserKnowledgeShareRequestByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUserKnowledgeShareRequestByFilter(_response);
        });
    }

    protected processGetAllUserKnowledgeShareRequestByFilter(response: AxiosResponse): Promise<GetAllUserKnowledgeShareRequestByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUserKnowledgeShareRequestByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUserKnowledgeShareRequestByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserSharedKnowledgeRequestById(body: GetUserSharedKnowledgeRequestByIdCommandRequest | undefined): Promise<GetUserSharedKnowledgeRequestByIdCommandResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/GetUserSharedKnowledgeRequestById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserSharedKnowledgeRequestById(_response);
        });
    }

    protected processGetUserSharedKnowledgeRequestById(response: AxiosResponse): Promise<GetUserSharedKnowledgeRequestByIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserSharedKnowledgeRequestByIdCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserSharedKnowledgeRequestByIdCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addSharedKnowledgeRequest(body: AddKnowledgeShareCommandRequest | undefined): Promise<AddKnowledgeShareCommandResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/AddSharedKnowledgeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddSharedKnowledgeRequest(_response);
        });
    }

    protected processAddSharedKnowledgeRequest(response: AxiosResponse): Promise<AddKnowledgeShareCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddKnowledgeShareCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddKnowledgeShareCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveKnowledgeShare(body: ApproveKnowledgeShareCommandRequest | undefined): Promise<ApproveKnowledgeShareCommandResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/ApproveKnowledgeShare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processApproveKnowledgeShare(_response);
        });
    }

    protected processApproveKnowledgeShare(response: AxiosResponse): Promise<ApproveKnowledgeShareCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApproveKnowledgeShareCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApproveKnowledgeShareCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectKnowledgeShare(body: RejectKnowledgeShareCommandRequest | undefined): Promise<RejectKnowledgeShareCommandResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/RejectKnowledgeShare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRejectKnowledgeShare(_response);
        });
    }

    protected processRejectKnowledgeShare(response: AxiosResponse): Promise<RejectKnowledgeShareCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RejectKnowledgeShareCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RejectKnowledgeShareCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllSharedKnowledgeByFilter(body: GetAllSharedKnowledgeByFilterQueryRequest | undefined): Promise<GetAllSharedKnowledgeByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/SharedKnowledgeManagement/GetAllSharedKnowledgeByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllSharedKnowledgeByFilter(_response);
        });
    }

    protected processGetAllSharedKnowledgeByFilter(response: AxiosResponse): Promise<GetAllSharedKnowledgeByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllSharedKnowledgeByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllSharedKnowledgeByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersByFilter(body: GetAllUsersByFilterQueryRequest | undefined): Promise<GetAllUsersByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllUsersByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUsersByFilter(_response);
        });
    }

    protected processGetAllUsersByFilter(response: AxiosResponse): Promise<GetAllUsersByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUsersByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUsersByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserRegistrationByFilter(body: GetAllUserRegistrationByFilterQueryRequest | undefined): Promise<GetAllUserRegistrationByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllUserRegistrationByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUserRegistrationByFilter(_response);
        });
    }

    protected processGetAllUserRegistrationByFilter(response: AxiosResponse): Promise<GetAllUserRegistrationByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUserRegistrationByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUserRegistrationByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUsersReportData(body: GetAllUsersReportDataQueryRequest | undefined): Promise<GetAllUsersReportDataQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllUsersReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUsersReportData(_response);
        });
    }

    protected processGetAllUsersReportData(response: AxiosResponse): Promise<GetAllUsersReportDataQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUsersReportDataQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUsersReportDataQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserById(body: GetUserByIdQueryRequest | undefined): Promise<GetUserByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetUserById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<GetUserByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserRegistrationById(body: GetUserRegistrationByIdQueryRequest | undefined): Promise<GetUserRegistrationByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetUserRegistrationById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserRegistrationById(_response);
        });
    }

    protected processGetUserRegistrationById(response: AxiosResponse): Promise<GetUserRegistrationByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserRegistrationByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserRegistrationByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveUserRegistrationById(body: ApproveUserRegistrationCommandRequest | undefined): Promise<ApproveUserRegistrationCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/ApproveUserRegistrationById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processApproveUserRegistrationById(_response);
        });
    }

    protected processApproveUserRegistrationById(response: AxiosResponse): Promise<ApproveUserRegistrationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApproveUserRegistrationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApproveUserRegistrationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectUserRegistrationById(body: RejectUserRegistrationCommandRequest | undefined): Promise<RejectUserRegistrationCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/RejectUserRegistrationById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRejectUserRegistrationById(_response);
        });
    }

    protected processRejectUserRegistrationById(response: AxiosResponse): Promise<RejectUserRegistrationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RejectUserRegistrationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RejectUserRegistrationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserStatus(body: ChangeUserStatusCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/ChangeUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeUserStatus(_response);
        });
    }

    protected processChangeUserStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUser(body: EditUserCommandRequest | undefined): Promise<EditUserCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/EditUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditUser(_response);
        });
    }

    protected processEditUser(response: AxiosResponse): Promise<EditUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerUser(body: RegisterUserCommandRequest | undefined): Promise<RegisterUserCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/RegisterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegisterUser(_response);
        });
    }

    protected processRegisterUser(response: AxiosResponse): Promise<RegisterUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendConfirmationEmail(body: ResendConfirmationEmailCommandRequest | undefined): Promise<ResendConfirmationEmailCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/ResendConfirmationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResendConfirmationEmail(_response);
        });
    }

    protected processResendConfirmationEmail(response: AxiosResponse): Promise<ResendConfirmationEmailCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResendConfirmationEmailCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResendConfirmationEmailCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUser(body: RemoveUserCommandRequest | undefined): Promise<RemoveUserCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/RemoveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: AxiosResponse): Promise<RemoveUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: AddUserCommandRequest | undefined): Promise<AddUserCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: AxiosResponse): Promise<AddUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserInfoForPublicByFilter(body: GetAllUserInfoForPublicByFilterQueryRequest | undefined): Promise<GetAllUserInfoForPublicByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllUserInfoForPublicByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUserInfoForPublicByFilter(_response);
        });
    }

    protected processGetAllUserInfoForPublicByFilter(response: AxiosResponse): Promise<GetAllUserInfoForPublicByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUserInfoForPublicByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUserInfoForPublicByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRoleInfosForPublicByFilter(body: GetAllRoleInfosForPublicByFilterQueryRequest | undefined): Promise<GetAllRoleInfosForPublicByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GetAllRoleInfosForPublicByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllRoleInfosForPublicByFilter(_response);
        });
    }

    protected processGetAllRoleInfosForPublicByFilter(response: AxiosResponse): Promise<GetAllRoleInfosForPublicByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRoleInfosForPublicByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRoleInfosForPublicByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateUsersCsv(body: GenerateEnabledUsersCsvCommandRequest | undefined): Promise<GenerateEnabledUsersCsvCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GenerateUsersCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGenerateUsersCsv(_response);
        });
    }

    protected processGenerateUsersCsv(response: AxiosResponse): Promise<GenerateEnabledUsersCsvCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateEnabledUsersCsvCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateEnabledUsersCsvCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateUsersCsv2(body: GenerateEnabledUsersCsvCommandRequest | undefined): Promise<GenerateEnabledUsersCsvCommandResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/GenerateUsersCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "HEAD",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGenerateUsersCsv2(_response);
        });
    }

    protected processGenerateUsersCsv2(response: AxiosResponse): Promise<GenerateEnabledUsersCsvCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateEnabledUsersCsvCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateEnabledUsersCsvCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserPreference(body: GetUserPreferenceCommandRequest | undefined): Promise<GetUserPreferenceCommandResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/GetUserPreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserPreference(_response);
        });
    }

    protected processGetUserPreference(response: AxiosResponse): Promise<GetUserPreferenceCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserPreferenceCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserPreferenceCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertUserPreference(body: UpsertUserPreferenceCommandRequest | undefined): Promise<UpsertUserPreferenceCommandResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/UpsertUserPreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpsertUserPreference(_response);
        });
    }

    protected processUpsertUserPreference(response: AxiosResponse): Promise<UpsertUserPreferenceCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpsertUserPreferenceCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpsertUserPreferenceCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pinKnowledge(body: PinKnowledgeCommandRequest | undefined): Promise<PinKnowledgeCommandResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/PinKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPinKnowledge(_response);
        });
    }

    protected processPinKnowledge(response: AxiosResponse): Promise<PinKnowledgeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PinKnowledgeCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PinKnowledgeCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unPinKnowledge(body: UnPinKnowledgeCommandRequest | undefined): Promise<UnPinKnowledgeCommandResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/UnPinKnowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnPinKnowledge(_response);
        });
    }

    protected processUnPinKnowledge(response: AxiosResponse): Promise<UnPinKnowledgeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnPinKnowledgeCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnPinKnowledgeCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMyRecentKnowledgeByFilter(body: GetMyRecentKnowledgeByFilterQueryRequest | undefined): Promise<GetMyRecentKnowledgeByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/GetMyRecentKnowledgeByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMyRecentKnowledgeByFilter(_response);
        });
    }

    protected processGetMyRecentKnowledgeByFilter(response: AxiosResponse): Promise<GetMyRecentKnowledgeByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyRecentKnowledgeByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyRecentKnowledgeByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMyPinnedKnowledgeByFilter(body: GetMyPinnedKnowledgesByFilterQueryRequest | undefined): Promise<GetMyPinnedKnowledgesByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserPreferenceManagement/GetMyPinnedKnowledgeByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMyPinnedKnowledgeByFilter(_response);
        });
    }

    protected processGetMyPinnedKnowledgeByFilter(response: AxiosResponse): Promise<GetMyPinnedKnowledgesByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyPinnedKnowledgesByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyPinnedKnowledgesByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/RequestPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMyUserProfile(): Promise<GetMyUserProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/GetMyUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMyUserProfile(_response);
        });
    }

    protected processGetMyUserProfile(response: AxiosResponse): Promise<GetMyUserProfileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyUserProfileQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyUserProfileQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserProfile(body: GetUserProfileQueryRequest | undefined): Promise<GetUserProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<GetUserProfileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserProfileQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserProfileQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: EditUserProfileCommandRequest | undefined): Promise<EditUserProfileCommandResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/EditUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditUserProfile(_response);
        });
    }

    protected processEditUserProfile(response: AxiosResponse): Promise<EditUserProfileCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditUserProfileCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditUserProfileCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUserProfileByFilter(body: GetAllUserProfileByFilterQueryRequest | undefined): Promise<GetAllUserProfileByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/GetAllUserProfileByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllUserProfileByFilter(_response);
        });
    }

    protected processGetAllUserProfileByFilter(response: AxiosResponse): Promise<GetAllUserProfileByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllUserProfileByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUserProfileByFilterQueryResponse>(<any>null);
    }
}

export enum FilterType {
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
    LessThan = "LessThan",
    LessThanOrEqualTo = "LessThanOrEqualTo",
    Equal = "Equal",
    NotEqual = "NotEqual",
    Group = "Group",
}

export enum JoinType {
    And = "and",
    Or = "or",
}

export class Filter implements IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: Filter[] | undefined;
    ignore?: boolean;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groupFilters) {
                this.groupFilters = [];
                for (let i = 0; i < data.groupFilters.length; i++) {
                    let item = data.groupFilters[i];
                    this.groupFilters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterType = _data["filterType"];
            this.value = _data["value"];
            this.joinType = _data["joinType"];
            if (Array.isArray(_data["groupFilters"])) {
                this.groupFilters = [] as any;
                for (let item of _data["groupFilters"])
                    this.groupFilters!.push(Filter.fromJS(item));
            }
            this.ignore = _data["ignore"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterType"] = this.filterType;
        data["value"] = this.value;
        data["joinType"] = this.joinType;
        if (Array.isArray(this.groupFilters)) {
            data["groupFilters"] = [];
            for (let item of this.groupFilters)
                data["groupFilters"].push(item.toJSON());
        }
        data["ignore"] = this.ignore;
        return data; 
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: IFilter[] | undefined;
    ignore?: boolean;
}

export class OrderBy implements IOrderBy {
    field?: string | undefined;
    ascending?: boolean;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["ascending"] = this.ascending;
        return data; 
    }

    clone(): OrderBy {
        const json = this.toJSON();
        let result = new OrderBy();
        result.init(json);
        return result;
    }
}

export interface IOrderBy {
    field?: string | undefined;
    ascending?: boolean;
}

export class GetAllAuditHeaderByFilterModel implements IGetAllAuditHeaderByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllAuditHeaderByFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAuditHeaderByFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditHeaderByFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllAuditHeaderByFilterModel {
        const json = this.toJSON();
        let result = new GetAllAuditHeaderByFilterModel();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditHeaderByFilterModel {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum UserStatus {
    Disabled = "Disabled",
    Active = "Active",
    Pending = "Pending",
    Rejected = "Rejected",
}

export class Country implements ICountry {
    name?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdiction?: Jurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.twoLetterCode = _data["twoLetterCode"];
            this.threeLetterCode = _data["threeLetterCode"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["twoLetterCode"] = this.twoLetterCode;
        data["threeLetterCode"] = this.threeLetterCode;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdiction?: IJurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum JurisdictionStatus {
    InActive = "InActive",
    Active = "Active",
    Pending = "Pending",
}

export class Jurisdiction implements IJurisdiction {
    name?: string | undefined;
    shortDescription?: string | undefined;
    countries?: Country[] | undefined;
    active?: boolean;
    flagIconPathOrName?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;
    status?: JurisdictionStatus;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IJurisdiction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.countries) {
                this.countries = [];
                for (let i = 0; i < data.countries.length; i++) {
                    let item = data.countries[i];
                    this.countries[i] = item && !(<any>item).toJSON ? new Country(item) : <Country>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(Country.fromJS(item));
            }
            this.active = _data["active"];
            this.flagIconPathOrName = _data["flagIconPathOrName"];
            this.description = _data["description"];
            this.deleted = _data["deleted"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Jurisdiction {
        data = typeof data === 'object' ? data : {};
        let result = new Jurisdiction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        data["active"] = this.active;
        data["flagIconPathOrName"] = this.flagIconPathOrName;
        data["description"] = this.description;
        data["deleted"] = this.deleted;
        data["status"] = this.status;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Jurisdiction {
        const json = this.toJSON();
        let result = new Jurisdiction();
        result.init(json);
        return result;
    }
}

export interface IJurisdiction {
    name?: string | undefined;
    shortDescription?: string | undefined;
    countries?: ICountry[] | undefined;
    active?: boolean;
    flagIconPathOrName?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;
    status?: JurisdictionStatus;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum RoleStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class Role implements IRole {
    description?: string | undefined;
    status?: RoleStatus;
    jurisdictionId?: string | undefined;
    jurisdiction?: Jurisdiction | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: UserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.status = _data["status"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["status"] = this.status;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        return data; 
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    description?: string | undefined;
    status?: RoleStatus;
    jurisdictionId?: string | undefined;
    jurisdiction?: IJurisdiction | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: IUserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class UserRole implements IUserRole {
    userId?: string;
    user?: User | undefined;
    roleId?: string;
    role?: Role | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    userId?: string;
    user?: IUser | undefined;
    roleId?: string;
    role?: IRole | undefined;
}

export class DataFile implements IDataFile {
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    size?: number | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IDataFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): DataFile {
        data = typeof data === 'object' ? data : {};
        let result = new DataFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): DataFile {
        const json = this.toJSON();
        let result = new DataFile();
        result.init(json);
        return result;
    }
}

export interface IDataFile {
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    size?: number | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class UserPreference implements IUserPreference {
    userId?: string;
    user?: User | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IUserPreference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UserPreference {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): UserPreference {
        const json = this.toJSON();
        let result = new UserPreference();
        result.init(json);
        return result;
    }
}

export interface IUserPreference {
    userId?: string;
    user?: IUser | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class User implements IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: UserStatus;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdiction?: Jurisdiction | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: UserRole[] | undefined;
    deleted?: boolean | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
    notes?: string | undefined;
    image?: DataFile | undefined;
    imageId?: string | undefined;
    userPreferenceId?: string | undefined;
    userPreference?: UserPreference | undefined;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
            this.image = data.image && !(<any>data.image).toJSON ? new DataFile(data.image) : <DataFile>this.image; 
            this.userPreference = data.userPreference && !(<any>data.userPreference).toJSON ? new UserPreference(data.userPreference) : <UserPreference>this.userPreference; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.deleted = _data["deleted"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.department = _data["department"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.otherPhoneNumberType = _data["otherPhoneNumberType"];
            this.notes = _data["notes"];
            this.image = _data["image"] ? DataFile.fromJS(_data["image"]) : <any>undefined;
            this.imageId = _data["imageId"];
            this.userPreferenceId = _data["userPreferenceId"];
            this.userPreference = _data["userPreference"] ? UserPreference.fromJS(_data["userPreference"]) : <any>undefined;
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["clientSideConfig"] = this.clientSideConfig;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["deleted"] = this.deleted;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["department"] = this.department;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        data["notes"] = this.notes;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["imageId"] = this.imageId;
        data["userPreferenceId"] = this.userPreferenceId;
        data["userPreference"] = this.userPreference ? this.userPreference.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: UserStatus;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdiction?: IJurisdiction | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: IUserRole[] | undefined;
    deleted?: boolean | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
    notes?: string | undefined;
    image?: IDataFile | undefined;
    imageId?: string | undefined;
    userPreferenceId?: string | undefined;
    userPreference?: IUserPreference | undefined;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export enum AuditStatus {
    Attempt = "Attempt",
    Success = "Success",
    Failure = "Failure",
}

export enum AuditEvent {
    Added = "Added",
    Deleted = "Deleted",
    Modified = "Modified",
    Queried = "Queried",
    Attempted = "Attempted",
}

export class AuditDetail implements IAuditDetail {
    auditHeaderId?: string;
    auditEvent?: AuditEvent;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditHeader?: AuditHeader | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.auditHeader = data.auditHeader && !(<any>data.auditHeader).toJSON ? new AuditHeader(data.auditHeader) : <AuditHeader>this.auditHeader; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditHeaderId = _data["auditHeaderId"];
            this.auditEvent = _data["auditEvent"];
            this.entityName = _data["entityName"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.auditHeader = _data["auditHeader"] ? AuditHeader.fromJS(_data["auditHeader"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditHeaderId"] = this.auditHeaderId;
        data["auditEvent"] = this.auditEvent;
        data["entityName"] = this.entityName;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["auditHeader"] = this.auditHeader ? this.auditHeader.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): AuditDetail {
        const json = this.toJSON();
        let result = new AuditDetail();
        result.init(json);
        return result;
    }
}

export interface IAuditDetail {
    auditHeaderId?: string;
    auditEvent?: AuditEvent;
    entityName?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    auditHeader?: IAuditHeader | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class AuditHeader implements IAuditHeader {
    auditedUserId?: string | undefined;
    auditedUser?: User | undefined;
    auditedUserName?: string | undefined;
    operation?: string | undefined;
    auditTime?: string;
    auditStatus?: AuditStatus;
    auditDetails?: AuditDetail[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IAuditHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.auditedUser = data.auditedUser && !(<any>data.auditedUser).toJSON ? new User(data.auditedUser) : <User>this.auditedUser; 
            if (data.auditDetails) {
                this.auditDetails = [];
                for (let i = 0; i < data.auditDetails.length; i++) {
                    let item = data.auditDetails[i];
                    this.auditDetails[i] = item && !(<any>item).toJSON ? new AuditDetail(item) : <AuditDetail>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditedUserId = _data["auditedUserId"];
            this.auditedUser = _data["auditedUser"] ? User.fromJS(_data["auditedUser"]) : <any>undefined;
            this.auditedUserName = _data["auditedUserName"];
            this.operation = _data["operation"];
            this.auditTime = _data["auditTime"];
            this.auditStatus = _data["auditStatus"];
            if (Array.isArray(_data["auditDetails"])) {
                this.auditDetails = [] as any;
                for (let item of _data["auditDetails"])
                    this.auditDetails!.push(AuditDetail.fromJS(item));
            }
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AuditHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AuditHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditedUserId"] = this.auditedUserId;
        data["auditedUser"] = this.auditedUser ? this.auditedUser.toJSON() : <any>undefined;
        data["auditedUserName"] = this.auditedUserName;
        data["operation"] = this.operation;
        data["auditTime"] = this.auditTime;
        data["auditStatus"] = this.auditStatus;
        if (Array.isArray(this.auditDetails)) {
            data["auditDetails"] = [];
            for (let item of this.auditDetails)
                data["auditDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): AuditHeader {
        const json = this.toJSON();
        let result = new AuditHeader();
        result.init(json);
        return result;
    }
}

export interface IAuditHeader {
    auditedUserId?: string | undefined;
    auditedUser?: IUser | undefined;
    auditedUserName?: string | undefined;
    operation?: string | undefined;
    auditTime?: string;
    auditStatus?: AuditStatus;
    auditDetails?: IAuditDetail[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class GetAllAuditHeaderByFilterQueryResponse implements IGetAllAuditHeaderByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: AuditHeader[] | undefined;
    count?: number;

    constructor(data?: IGetAllAuditHeaderByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new AuditHeader(item) : <AuditHeader>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AuditHeader.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllAuditHeaderByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditHeaderByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllAuditHeaderByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllAuditHeaderByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditHeaderByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IAuditHeader[] | undefined;
    count?: number;
}

export class GetAuditByIdQueryRequest implements IGetAuditByIdQueryRequest {
    id?: string;

    constructor(data?: IGetAuditByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAuditByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAuditByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetAuditByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAuditByIdQueryRequest {
    id?: string;
}

export class GetAuditByIdQueryResponse implements IGetAuditByIdQueryResponse {
    header?: AuditHeader | undefined;

    constructor(data?: IGetAuditByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.header = data.header && !(<any>data.header).toJSON ? new AuditHeader(data.header) : <AuditHeader>this.header; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? AuditHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAuditByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAuditByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetAuditByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAuditByIdQueryResponse {
    header?: IAuditHeader | undefined;
}

export class GetUserLoginReportDataQueryRequest implements IGetUserLoginReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetUserLoginReportDataQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserLoginReportDataQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginReportDataQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetUserLoginReportDataQueryRequest {
        const json = this.toJSON();
        let result = new GetUserLoginReportDataQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserLoginReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class UserLoginReportModel implements IUserLoginReportModel {
    userName?: string | undefined;
    userFullName?: string | undefined;
    auditStatus?: AuditStatus;
    creationDate?: string | undefined;
    userId?: string | undefined;
    readonly jurisdictionName?: string | undefined;

    constructor(data?: IUserLoginReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userFullName = _data["userFullName"];
            this.auditStatus = _data["auditStatus"];
            this.creationDate = _data["creationDate"];
            this.userId = _data["userId"];
            (<any>this).jurisdictionName = _data["jurisdictionName"];
        }
    }

    static fromJS(data: any): UserLoginReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userFullName"] = this.userFullName;
        data["auditStatus"] = this.auditStatus;
        data["creationDate"] = this.creationDate;
        data["userId"] = this.userId;
        data["jurisdictionName"] = this.jurisdictionName;
        return data; 
    }

    clone(): UserLoginReportModel {
        const json = this.toJSON();
        let result = new UserLoginReportModel();
        result.init(json);
        return result;
    }
}

export interface IUserLoginReportModel {
    userName?: string | undefined;
    userFullName?: string | undefined;
    auditStatus?: AuditStatus;
    creationDate?: string | undefined;
    userId?: string | undefined;
    jurisdictionName?: string | undefined;
}

export class GetUserLoginReportDataQueryResponse implements IGetUserLoginReportDataQueryResponse {
    jurisdictions?: string | undefined;
    creationDateRange?: string | undefined;
    reportDate?: string;
    readonly users?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: UserLoginReportModel[] | undefined;
    count?: number;

    constructor(data?: IGetUserLoginReportDataQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new UserLoginReportModel(item) : <UserLoginReportModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdictions = _data["jurisdictions"];
            this.creationDateRange = _data["creationDateRange"];
            this.reportDate = _data["reportDate"];
            (<any>this).users = _data["users"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserLoginReportModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetUserLoginReportDataQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginReportDataQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdictions"] = this.jurisdictions;
        data["creationDateRange"] = this.creationDateRange;
        data["reportDate"] = this.reportDate;
        data["users"] = this.users;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetUserLoginReportDataQueryResponse {
        const json = this.toJSON();
        let result = new GetUserLoginReportDataQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserLoginReportDataQueryResponse {
    jurisdictions?: string | undefined;
    creationDateRange?: string | undefined;
    reportDate?: string;
    users?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IUserLoginReportModel[] | undefined;
    count?: number;
}

export class GetAllAuditTypesQueryRequest implements IGetAllAuditTypesQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllAuditTypesQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAuditTypesQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditTypesQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllAuditTypesQueryRequest {
        const json = this.toJSON();
        let result = new GetAllAuditTypesQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditTypesQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllAuditTypesQueryResponse implements IGetAllAuditTypesQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: string[] | undefined;
    count?: number;

    constructor(data?: IGetAllAuditTypesQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllAuditTypesQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAuditTypesQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllAuditTypesQueryResponse {
        const json = this.toJSON();
        let result = new GetAllAuditTypesQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAuditTypesQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: string[] | undefined;
    count?: number;
}

export class AddCategoryCommandRequest implements IAddCategoryCommandRequest {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAddCategoryCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AddCategoryCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCategoryCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): AddCategoryCommandRequest {
        const json = this.toJSON();
        let result = new AddCategoryCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCategoryCommandRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data; 
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class KnowledgeCategory implements IKnowledgeCategory {
    name?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledgeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.deleted = _data["deleted"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): KnowledgeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["deleted"] = this.deleted;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): KnowledgeCategory {
        const json = this.toJSON();
        let result = new KnowledgeCategory();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeCategory {
    name?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class EditCategoryCommandRequest implements IEditCategoryCommandRequest {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IEditCategoryCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EditCategoryCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCategoryCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): EditCategoryCommandRequest {
        const json = this.toJSON();
        let result = new EditCategoryCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditCategoryCommandRequest {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
}

export class RemoveCategoryCommandRequest implements IRemoveCategoryCommandRequest {
    id?: string;

    constructor(data?: IRemoveCategoryCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveCategoryCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCategoryCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): RemoveCategoryCommandRequest {
        const json = this.toJSON();
        let result = new RemoveCategoryCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveCategoryCommandRequest {
    id?: string;
}

export class GetCategoryByIdQueryRequest implements IGetCategoryByIdQueryRequest {
    id?: string | undefined;

    constructor(data?: IGetCategoryByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCategoryByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetCategoryByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetCategoryByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetCategoryByIdQueryRequest {
    id?: string | undefined;
}

export class GetCategoryByIdQueryResponse implements IGetCategoryByIdQueryResponse {
    category?: KnowledgeCategory | undefined;

    constructor(data?: IGetCategoryByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new KnowledgeCategory(data.category) : <KnowledgeCategory>this.category; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] ? KnowledgeCategory.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCategoryByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCategoryByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetCategoryByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCategoryByIdQueryResponse {
    category?: IKnowledgeCategory | undefined;
}

export class AddCommentCommandRequest implements IAddCommentCommandRequest {
    knowledgeId?: string;
    comment?: string | undefined;
    replyCommentId?: string | undefined;

    constructor(data?: IAddCommentCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
            this.comment = _data["comment"];
            this.replyCommentId = _data["replyCommentId"];
        }
    }

    static fromJS(data: any): AddCommentCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCommentCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        data["comment"] = this.comment;
        data["replyCommentId"] = this.replyCommentId;
        return data; 
    }

    clone(): AddCommentCommandRequest {
        const json = this.toJSON();
        let result = new AddCommentCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCommentCommandRequest {
    knowledgeId?: string;
    comment?: string | undefined;
    replyCommentId?: string | undefined;
}

export class EditCommentCommandRequest implements IEditCommentCommandRequest {
    id?: string;
    commentDetails?: string | undefined;

    constructor(data?: IEditCommentCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commentDetails = _data["commentDetails"];
        }
    }

    static fromJS(data: any): EditCommentCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommentCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commentDetails"] = this.commentDetails;
        return data; 
    }

    clone(): EditCommentCommandRequest {
        const json = this.toJSON();
        let result = new EditCommentCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditCommentCommandRequest {
    id?: string;
    commentDetails?: string | undefined;
}

export class DeleteCommentCommandRequest implements IDeleteCommentCommandRequest {
    id?: string;

    constructor(data?: IDeleteCommentCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCommentCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCommentCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): DeleteCommentCommandRequest {
        const json = this.toJSON();
        let result = new DeleteCommentCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteCommentCommandRequest {
    id?: string;
}

export class GetAllCommentsForKnowledgeByFilterQueryRequest implements IGetAllCommentsForKnowledgeByFilterQueryRequest {
    knowledgeId?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllCommentsForKnowledgeByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCommentsForKnowledgeByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCommentsForKnowledgeByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllCommentsForKnowledgeByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllCommentsForKnowledgeByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllCommentsForKnowledgeByFilterQueryRequest {
    knowledgeId?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum AccessLevel {
    Public = "Public",
    Level1 = "Level1",
    Level2 = "Level2",
    Level3 = "Level3",
    Level4 = "Level4",
    Level5 = "Level5",
    NoAccess = "NoAccess",
}

export class Document implements IDocument {
    name?: string | undefined;
    dataFileId?: string;
    dataFile?: DataFile | undefined;
    knowledgeId?: string;
    knowledge?: Knowledge | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataFile = data.dataFile && !(<any>data.dataFile).toJSON ? new DataFile(data.dataFile) : <DataFile>this.dataFile; 
            this.knowledge = data.knowledge && !(<any>data.knowledge).toJSON ? new Knowledge(data.knowledge) : <Knowledge>this.knowledge; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dataFileId = _data["dataFileId"];
            this.dataFile = _data["dataFile"] ? DataFile.fromJS(_data["dataFile"]) : <any>undefined;
            this.knowledgeId = _data["knowledgeId"];
            this.knowledge = _data["knowledge"] ? Knowledge.fromJS(_data["knowledge"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataFileId"] = this.dataFileId;
        data["dataFile"] = this.dataFile ? this.dataFile.toJSON() : <any>undefined;
        data["knowledgeId"] = this.knowledgeId;
        data["knowledge"] = this.knowledge ? this.knowledge.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Document {
        const json = this.toJSON();
        let result = new Document();
        result.init(json);
        return result;
    }
}

export interface IDocument {
    name?: string | undefined;
    dataFileId?: string;
    dataFile?: IDataFile | undefined;
    knowledgeId?: string;
    knowledge?: IKnowledge | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class KnowledgeDataTemplate implements IKnowledgeDataTemplate {
    name?: string | undefined;
    knowledgeCategoryId?: string;
    knowledgeCategory?: KnowledgeCategory | undefined;
    description?: string | undefined;
    templateJSON?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledgeDataTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledgeCategory = data.knowledgeCategory && !(<any>data.knowledgeCategory).toJSON ? new KnowledgeCategory(data.knowledgeCategory) : <KnowledgeCategory>this.knowledgeCategory; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.knowledgeCategoryId = _data["knowledgeCategoryId"];
            this.knowledgeCategory = _data["knowledgeCategory"] ? KnowledgeCategory.fromJS(_data["knowledgeCategory"]) : <any>undefined;
            this.description = _data["description"];
            this.templateJSON = _data["templateJSON"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): KnowledgeDataTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeDataTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["knowledgeCategoryId"] = this.knowledgeCategoryId;
        data["knowledgeCategory"] = this.knowledgeCategory ? this.knowledgeCategory.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["templateJSON"] = this.templateJSON;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): KnowledgeDataTemplate {
        const json = this.toJSON();
        let result = new KnowledgeDataTemplate();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeDataTemplate {
    name?: string | undefined;
    knowledgeCategoryId?: string;
    knowledgeCategory?: IKnowledgeCategory | undefined;
    description?: string | undefined;
    templateJSON?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum KnowledgeStatus {
    Draft = "Draft",
    Published = "Published",
}

export class Knowledge implements IKnowledge {
    title?: string | undefined;
    description?: string | undefined;
    categoryId?: string;
    accessLevel?: AccessLevel;
    category?: KnowledgeCategory | undefined;
    documents?: Document[] | undefined;
    comments?: KnowledgeComment[] | undefined;
    knowledgeDataTemplateId?: string | undefined;
    knowledgeDataTemplate?: KnowledgeDataTemplate | undefined;
    currentlySelectedTemplateJSON?: string | undefined;
    searchIndexedDate?: string | undefined;
    templateDataJSON?: string | undefined;
    templateSearchData?: string | undefined;
    deleted?: boolean | undefined;
    status?: KnowledgeStatus;
    jurisdictionId?: string;
    jurisdiction?: Jurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new KnowledgeCategory(data.category) : <KnowledgeCategory>this.category; 
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new Document(item) : <Document>item;
                }
            }
            if (data.comments) {
                this.comments = [];
                for (let i = 0; i < data.comments.length; i++) {
                    let item = data.comments[i];
                    this.comments[i] = item && !(<any>item).toJSON ? new KnowledgeComment(item) : <KnowledgeComment>item;
                }
            }
            this.knowledgeDataTemplate = data.knowledgeDataTemplate && !(<any>data.knowledgeDataTemplate).toJSON ? new KnowledgeDataTemplate(data.knowledgeDataTemplate) : <KnowledgeDataTemplate>this.knowledgeDataTemplate; 
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.accessLevel = _data["accessLevel"];
            this.category = _data["category"] ? KnowledgeCategory.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(KnowledgeComment.fromJS(item));
            }
            this.knowledgeDataTemplateId = _data["knowledgeDataTemplateId"];
            this.knowledgeDataTemplate = _data["knowledgeDataTemplate"] ? KnowledgeDataTemplate.fromJS(_data["knowledgeDataTemplate"]) : <any>undefined;
            this.currentlySelectedTemplateJSON = _data["currentlySelectedTemplateJSON"];
            this.searchIndexedDate = _data["searchIndexedDate"];
            this.templateDataJSON = _data["templateDataJSON"];
            this.templateSearchData = _data["templateSearchData"];
            this.deleted = _data["deleted"];
            this.status = _data["status"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Knowledge {
        data = typeof data === 'object' ? data : {};
        let result = new Knowledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["accessLevel"] = this.accessLevel;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["knowledgeDataTemplateId"] = this.knowledgeDataTemplateId;
        data["knowledgeDataTemplate"] = this.knowledgeDataTemplate ? this.knowledgeDataTemplate.toJSON() : <any>undefined;
        data["currentlySelectedTemplateJSON"] = this.currentlySelectedTemplateJSON;
        data["searchIndexedDate"] = this.searchIndexedDate;
        data["templateDataJSON"] = this.templateDataJSON;
        data["templateSearchData"] = this.templateSearchData;
        data["deleted"] = this.deleted;
        data["status"] = this.status;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Knowledge {
        const json = this.toJSON();
        let result = new Knowledge();
        result.init(json);
        return result;
    }
}

export interface IKnowledge {
    title?: string | undefined;
    description?: string | undefined;
    categoryId?: string;
    accessLevel?: AccessLevel;
    category?: IKnowledgeCategory | undefined;
    documents?: IDocument[] | undefined;
    comments?: IKnowledgeComment[] | undefined;
    knowledgeDataTemplateId?: string | undefined;
    knowledgeDataTemplate?: IKnowledgeDataTemplate | undefined;
    currentlySelectedTemplateJSON?: string | undefined;
    searchIndexedDate?: string | undefined;
    templateDataJSON?: string | undefined;
    templateSearchData?: string | undefined;
    deleted?: boolean | undefined;
    status?: KnowledgeStatus;
    jurisdictionId?: string;
    jurisdiction?: IJurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class KnowledgeComment implements IKnowledgeComment {
    comment?: string | undefined;
    knowledgeId?: string;
    knowledge?: Knowledge | undefined;
    authorName?: string | undefined;
    parentId?: string | undefined;
    parent?: KnowledgeComment | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledgeComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledge = data.knowledge && !(<any>data.knowledge).toJSON ? new Knowledge(data.knowledge) : <Knowledge>this.knowledge; 
            this.parent = data.parent && !(<any>data.parent).toJSON ? new KnowledgeComment(data.parent) : <KnowledgeComment>this.parent; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.knowledgeId = _data["knowledgeId"];
            this.knowledge = _data["knowledge"] ? Knowledge.fromJS(_data["knowledge"]) : <any>undefined;
            this.authorName = _data["authorName"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? KnowledgeComment.fromJS(_data["parent"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): KnowledgeComment {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["knowledgeId"] = this.knowledgeId;
        data["knowledge"] = this.knowledge ? this.knowledge.toJSON() : <any>undefined;
        data["authorName"] = this.authorName;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): KnowledgeComment {
        const json = this.toJSON();
        let result = new KnowledgeComment();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeComment {
    comment?: string | undefined;
    knowledgeId?: string;
    knowledge?: IKnowledge | undefined;
    authorName?: string | undefined;
    parentId?: string | undefined;
    parent?: IKnowledgeComment | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class GetAllCommentsForKnowledgeByFilterQueryResponse implements IGetAllCommentsForKnowledgeByFilterQueryResponse {
    knowledgeId?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: KnowledgeComment[] | undefined;
    count?: number;

    constructor(data?: IGetAllCommentsForKnowledgeByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new KnowledgeComment(item) : <KnowledgeComment>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KnowledgeComment.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllCommentsForKnowledgeByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCommentsForKnowledgeByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllCommentsForKnowledgeByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllCommentsForKnowledgeByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllCommentsForKnowledgeByFilterQueryResponse {
    knowledgeId?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledgeComment[] | undefined;
    count?: number;
}

export class StringStringValuesKeyValuePair implements IStringStringValuesKeyValuePair {
    readonly key?: string | undefined;
    readonly value?: string[];

    constructor(data?: IStringStringValuesKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).key = _data["key"];
            if (Array.isArray(_data["value"])) {
                (<any>this).value = [] as any;
                for (let item of _data["value"])
                    (<any>this).value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringValuesKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringValuesKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data; 
    }

    clone(): StringStringValuesKeyValuePair {
        const json = this.toJSON();
        let result = new StringStringValuesKeyValuePair();
        result.init(json);
        return result;
    }
}

export interface IStringStringValuesKeyValuePair {
    key?: string | undefined;
    value?: string[];
}

export class SpellCheckJsonData implements ISpellCheckJsonData {
    languageID?: number;
    texttoCheck?: string | undefined;
    checkSpelling?: boolean;
    checkSuggestion?: boolean;
    addWord?: boolean;

    constructor(data?: ISpellCheckJsonData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageID = _data["languageID"];
            this.texttoCheck = _data["texttoCheck"];
            this.checkSpelling = _data["checkSpelling"];
            this.checkSuggestion = _data["checkSuggestion"];
            this.addWord = _data["addWord"];
        }
    }

    static fromJS(data: any): SpellCheckJsonData {
        data = typeof data === 'object' ? data : {};
        let result = new SpellCheckJsonData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageID"] = this.languageID;
        data["texttoCheck"] = this.texttoCheck;
        data["checkSpelling"] = this.checkSpelling;
        data["checkSuggestion"] = this.checkSuggestion;
        data["addWord"] = this.addWord;
        return data; 
    }

    clone(): SpellCheckJsonData {
        const json = this.toJSON();
        let result = new SpellCheckJsonData();
        result.init(json);
        return result;
    }
}

export interface ISpellCheckJsonData {
    languageID?: number;
    texttoCheck?: string | undefined;
    checkSpelling?: boolean;
    checkSuggestion?: boolean;
    addWord?: boolean;
}

export class CustomParameter implements ICustomParameter {
    content?: string | undefined;
    type?: string | undefined;

    constructor(data?: ICustomParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CustomParameter {
        data = typeof data === 'object' ? data : {};
        let result = new CustomParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["type"] = this.type;
        return data; 
    }

    clone(): CustomParameter {
        const json = this.toJSON();
        let result = new CustomParameter();
        result.init(json);
        return result;
    }
}

export interface ICustomParameter {
    content?: string | undefined;
    type?: string | undefined;
}

export class CustomRestrictParameter implements ICustomRestrictParameter {
    passwordBase64?: string | undefined;
    saltBase64?: string | undefined;
    spinCount?: number;

    constructor(data?: ICustomRestrictParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordBase64 = _data["passwordBase64"];
            this.saltBase64 = _data["saltBase64"];
            this.spinCount = _data["spinCount"];
        }
    }

    static fromJS(data: any): CustomRestrictParameter {
        data = typeof data === 'object' ? data : {};
        let result = new CustomRestrictParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordBase64"] = this.passwordBase64;
        data["saltBase64"] = this.saltBase64;
        data["spinCount"] = this.spinCount;
        return data; 
    }

    clone(): CustomRestrictParameter {
        const json = this.toJSON();
        let result = new CustomRestrictParameter();
        result.init(json);
        return result;
    }
}

export interface ICustomRestrictParameter {
    passwordBase64?: string | undefined;
    saltBase64?: string | undefined;
    spinCount?: number;
}

export class AddDocumentModel implements IAddDocumentModel {
    knowledgeId?: string | undefined;
    content?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAddDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
            this.content = _data["content"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        data["content"] = this.content;
        data["name"] = this.name;
        return data; 
    }

    clone(): AddDocumentModel {
        const json = this.toJSON();
        let result = new AddDocumentModel();
        result.init(json);
        return result;
    }
}

export interface IAddDocumentModel {
    knowledgeId?: string | undefined;
    content?: string | undefined;
    name?: string | undefined;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canTimeout?: boolean;
    readonly canWrite?: boolean;
    readonly length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    canWrite?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class DocumentModel implements IDocumentModel {
    id?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    size?: number | undefined;
    content?: Stream | undefined;
    url?: string | undefined;
    readonly uploaderName?: string | undefined;
    readonly uploadDate?: string | undefined;
    readonly upLoaderId?: string | undefined;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.content = data.content && !(<any>data.content).toJSON ? new Stream(data.content) : <Stream>this.content; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.content = _data["content"] ? Stream.fromJS(_data["content"]) : <any>undefined;
            this.url = _data["url"];
            (<any>this).uploaderName = _data["uploaderName"];
            (<any>this).uploadDate = _data["uploadDate"];
            (<any>this).upLoaderId = _data["upLoaderId"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["url"] = this.url;
        data["uploaderName"] = this.uploaderName;
        data["uploadDate"] = this.uploadDate;
        data["upLoaderId"] = this.upLoaderId;
        return data; 
    }

    clone(): DocumentModel {
        const json = this.toJSON();
        let result = new DocumentModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentModel {
    id?: string | undefined;
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    size?: number | undefined;
    content?: IStream | undefined;
    url?: string | undefined;
    uploaderName?: string | undefined;
    uploadDate?: string | undefined;
    upLoaderId?: string | undefined;
}

export class DeleteDocumentCommandRequest implements IDeleteDocumentCommandRequest {
    id?: string | undefined;

    constructor(data?: IDeleteDocumentCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteDocumentCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): DeleteDocumentCommandRequest {
        const json = this.toJSON();
        let result = new DeleteDocumentCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteDocumentCommandRequest {
    id?: string | undefined;
}

export class MemoryStream implements IMemoryStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    capacity?: number;
    readonly length?: number;
    position?: number;
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): MemoryStream {
        const json = this.toJSON();
        let result = new MemoryStream();
        result.init(json);
        return result;
    }
}

export interface IMemoryStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class GetFileByIdQueryResponse implements IGetFileByIdQueryResponse {
    file?: MemoryStream | undefined;
    readonly name?: string | undefined;
    extension?: string | undefined;
    readonly mimeType?: string | undefined;

    constructor(data?: IGetFileByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new MemoryStream(data.file) : <MemoryStream>this.file; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? MemoryStream.fromJS(_data["file"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.extension = _data["extension"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): GetFileByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        return data; 
    }

    clone(): GetFileByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetFileByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFileByIdQueryResponse {
    file?: IMemoryStream | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
}

export class AddJurisdictionCommandRequest implements IAddJurisdictionCommandRequest {
    name?: string | undefined;
    shortDescription?: string | undefined;
    description?: string | undefined;
    flagIconPathOrName?: string | undefined;

    constructor(data?: IAddJurisdictionCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.flagIconPathOrName = _data["flagIconPathOrName"];
        }
    }

    static fromJS(data: any): AddJurisdictionCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddJurisdictionCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["flagIconPathOrName"] = this.flagIconPathOrName;
        return data; 
    }

    clone(): AddJurisdictionCommandRequest {
        const json = this.toJSON();
        let result = new AddJurisdictionCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddJurisdictionCommandRequest {
    name?: string | undefined;
    shortDescription?: string | undefined;
    description?: string | undefined;
    flagIconPathOrName?: string | undefined;
}

export class RemoveJurisdictionCommandRequest implements IRemoveJurisdictionCommandRequest {
    id?: string;

    constructor(data?: IRemoveJurisdictionCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveJurisdictionCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveJurisdictionCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): RemoveJurisdictionCommandRequest {
        const json = this.toJSON();
        let result = new RemoveJurisdictionCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveJurisdictionCommandRequest {
    id?: string;
}

export class RemoveJurisdictionCommandResponse implements IRemoveJurisdictionCommandResponse {

    constructor(data?: IRemoveJurisdictionCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveJurisdictionCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveJurisdictionCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): RemoveJurisdictionCommandResponse {
        const json = this.toJSON();
        let result = new RemoveJurisdictionCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveJurisdictionCommandResponse {
}

export class EditJurisdictionCommandRequest implements IEditJurisdictionCommandRequest {
    id?: string;
    name?: string | undefined;
    shortDescription?: string | undefined;
    description?: string | undefined;
    flagIconPathOrName?: string | undefined;

    constructor(data?: IEditJurisdictionCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.flagIconPathOrName = _data["flagIconPathOrName"];
        }
    }

    static fromJS(data: any): EditJurisdictionCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditJurisdictionCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["flagIconPathOrName"] = this.flagIconPathOrName;
        return data; 
    }

    clone(): EditJurisdictionCommandRequest {
        const json = this.toJSON();
        let result = new EditJurisdictionCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditJurisdictionCommandRequest {
    id?: string;
    name?: string | undefined;
    shortDescription?: string | undefined;
    description?: string | undefined;
    flagIconPathOrName?: string | undefined;
}

export class GetJurisdictionByIdQueryRequest implements IGetJurisdictionByIdQueryRequest {
    id?: string | undefined;

    constructor(data?: IGetJurisdictionByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetJurisdictionByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJurisdictionByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetJurisdictionByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetJurisdictionByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetJurisdictionByIdQueryRequest {
    id?: string | undefined;
}

export class GetJurisdictionByIdQueryResponse implements IGetJurisdictionByIdQueryResponse {
    jurisdiction?: Jurisdiction | undefined;

    constructor(data?: IGetJurisdictionByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJurisdictionByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJurisdictionByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetJurisdictionByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetJurisdictionByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetJurisdictionByIdQueryResponse {
    jurisdiction?: IJurisdiction | undefined;
}

export class CreateKnowledgeDataTemplateCommandRequest implements ICreateKnowledgeDataTemplateCommandRequest {
    name?: string | undefined;
    templateJSON?: string | undefined;
    description?: string | undefined;
    knowledgeCategoryId?: string | undefined;

    constructor(data?: ICreateKnowledgeDataTemplateCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.templateJSON = _data["templateJSON"];
            this.description = _data["description"];
            this.knowledgeCategoryId = _data["knowledgeCategoryId"];
        }
    }

    static fromJS(data: any): CreateKnowledgeDataTemplateCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKnowledgeDataTemplateCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["templateJSON"] = this.templateJSON;
        data["description"] = this.description;
        data["knowledgeCategoryId"] = this.knowledgeCategoryId;
        return data; 
    }

    clone(): CreateKnowledgeDataTemplateCommandRequest {
        const json = this.toJSON();
        let result = new CreateKnowledgeDataTemplateCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateKnowledgeDataTemplateCommandRequest {
    name?: string | undefined;
    templateJSON?: string | undefined;
    description?: string | undefined;
    knowledgeCategoryId?: string | undefined;
}

export class DeleteKnowledgeDataTemplateCommandRequest implements IDeleteKnowledgeDataTemplateCommandRequest {
    id?: string | undefined;

    constructor(data?: IDeleteKnowledgeDataTemplateCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteKnowledgeDataTemplateCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKnowledgeDataTemplateCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): DeleteKnowledgeDataTemplateCommandRequest {
        const json = this.toJSON();
        let result = new DeleteKnowledgeDataTemplateCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteKnowledgeDataTemplateCommandRequest {
    id?: string | undefined;
}

export class EditKnowledgeDataTemplateCommandRequest implements IEditKnowledgeDataTemplateCommandRequest {
    id?: string | undefined;
    name?: string | undefined;
    templateJSON?: string | undefined;
    description?: string | undefined;
    knowledgeCategoryId?: string | undefined;

    constructor(data?: IEditKnowledgeDataTemplateCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.templateJSON = _data["templateJSON"];
            this.description = _data["description"];
            this.knowledgeCategoryId = _data["knowledgeCategoryId"];
        }
    }

    static fromJS(data: any): EditKnowledgeDataTemplateCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditKnowledgeDataTemplateCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["templateJSON"] = this.templateJSON;
        data["description"] = this.description;
        data["knowledgeCategoryId"] = this.knowledgeCategoryId;
        return data; 
    }

    clone(): EditKnowledgeDataTemplateCommandRequest {
        const json = this.toJSON();
        let result = new EditKnowledgeDataTemplateCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditKnowledgeDataTemplateCommandRequest {
    id?: string | undefined;
    name?: string | undefined;
    templateJSON?: string | undefined;
    description?: string | undefined;
    knowledgeCategoryId?: string | undefined;
}

export class GetAllKnowledgeDataTemplatesByFilterQueryRequest implements IGetAllKnowledgeDataTemplatesByFilterQueryRequest {
    includeCategory?: boolean;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllKnowledgeDataTemplatesByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeCategory = _data["includeCategory"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllKnowledgeDataTemplatesByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllKnowledgeDataTemplatesByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeCategory"] = this.includeCategory;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllKnowledgeDataTemplatesByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllKnowledgeDataTemplatesByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllKnowledgeDataTemplatesByFilterQueryRequest {
    includeCategory?: boolean;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllKnowledgeDataTemplatesByFilterQueryResponse implements IGetAllKnowledgeDataTemplatesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: KnowledgeDataTemplate[] | undefined;
    count?: number;

    constructor(data?: IGetAllKnowledgeDataTemplatesByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new KnowledgeDataTemplate(item) : <KnowledgeDataTemplate>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KnowledgeDataTemplate.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllKnowledgeDataTemplatesByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllKnowledgeDataTemplatesByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllKnowledgeDataTemplatesByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllKnowledgeDataTemplatesByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllKnowledgeDataTemplatesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledgeDataTemplate[] | undefined;
    count?: number;
}

export class GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest implements IGetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllKnowledgeDataTemplatesForPublicByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetKnowledgeDataTemplateByIdCommandRequest implements IGetKnowledgeDataTemplateByIdCommandRequest {
    id?: string | undefined;

    constructor(data?: IGetKnowledgeDataTemplateByIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetKnowledgeDataTemplateByIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeDataTemplateByIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetKnowledgeDataTemplateByIdCommandRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeDataTemplateByIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeDataTemplateByIdCommandRequest {
    id?: string | undefined;
}

export class EditKnowledgeCommandRequest implements IEditKnowledgeCommandRequest {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    knowledgeDataTemplateId?: string | undefined;
    templateDataJSON?: string | undefined;
    categoryId?: string;
    documents?: Document[] | undefined;
    accessLevel?: AccessLevel | undefined;

    constructor(data?: IEditKnowledgeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new Document(item) : <Document>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.knowledgeDataTemplateId = _data["knowledgeDataTemplateId"];
            this.templateDataJSON = _data["templateDataJSON"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            this.accessLevel = _data["accessLevel"];
        }
    }

    static fromJS(data: any): EditKnowledgeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditKnowledgeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["knowledgeDataTemplateId"] = this.knowledgeDataTemplateId;
        data["templateDataJSON"] = this.templateDataJSON;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["accessLevel"] = this.accessLevel;
        return data; 
    }

    clone(): EditKnowledgeCommandRequest {
        const json = this.toJSON();
        let result = new EditKnowledgeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditKnowledgeCommandRequest {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    knowledgeDataTemplateId?: string | undefined;
    templateDataJSON?: string | undefined;
    categoryId?: string;
    documents?: IDocument[] | undefined;
    accessLevel?: AccessLevel | undefined;
}

export class DeleteKnowledgeCommandRequest implements IDeleteKnowledgeCommandRequest {
    id?: string;

    constructor(data?: IDeleteKnowledgeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteKnowledgeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKnowledgeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): DeleteKnowledgeCommandRequest {
        const json = this.toJSON();
        let result = new DeleteKnowledgeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteKnowledgeCommandRequest {
    id?: string;
}

export class GetAllKnowledgeByFilterQueryRequest implements IGetAllKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllKnowledgeByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllKnowledgeByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllKnowledgeByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllKnowledgeByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllKnowledgeByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllKnowledgeByFilterQueryResponse implements IGetAllKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Knowledge[] | undefined;
    count?: number;

    constructor(data?: IGetAllKnowledgeByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Knowledge(item) : <Knowledge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Knowledge.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllKnowledgeByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllKnowledgeByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllKnowledgeByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllKnowledgeByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledge[] | undefined;
    count?: number;
}

export class GetKnowledgeSummaryReportDataQueryRequest implements IGetKnowledgeSummaryReportDataQueryRequest {
    timeZone?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetKnowledgeSummaryReportDataQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKnowledgeSummaryReportDataQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeSummaryReportDataQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetKnowledgeSummaryReportDataQueryRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeSummaryReportDataQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeSummaryReportDataQueryRequest {
    timeZone?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class KnowledgeSummaryViewData implements IKnowledgeSummaryViewData {
    id?: string | undefined;
    title?: string | undefined;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    accessLevel?: AccessLevel;
    creationDate?: string | undefined;
    modificationDate?: string | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;

    constructor(data?: IKnowledgeSummaryViewData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.accessLevel = _data["accessLevel"];
            this.creationDate = _data["creationDate"];
            this.modificationDate = _data["modificationDate"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): KnowledgeSummaryViewData {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeSummaryViewData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["accessLevel"] = this.accessLevel;
        data["creationDate"] = this.creationDate;
        data["modificationDate"] = this.modificationDate;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        return data; 
    }

    clone(): KnowledgeSummaryViewData {
        const json = this.toJSON();
        let result = new KnowledgeSummaryViewData();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeSummaryViewData {
    id?: string | undefined;
    title?: string | undefined;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    accessLevel?: AccessLevel;
    creationDate?: string | undefined;
    modificationDate?: string | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
}

export class GetKnowledgeSummaryReportDataQueryResponse implements IGetKnowledgeSummaryReportDataQueryResponse {
    title?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    creationDateRange?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: KnowledgeSummaryViewData[] | undefined;
    count?: number;

    constructor(data?: IGetKnowledgeSummaryReportDataQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new KnowledgeSummaryViewData(item) : <KnowledgeSummaryViewData>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.accessLevel = _data["accessLevel"];
            this.jurisdictions = _data["jurisdictions"];
            this.categories = _data["categories"];
            this.reportDate = _data["reportDate"];
            this.creationDateRange = _data["creationDateRange"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KnowledgeSummaryViewData.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetKnowledgeSummaryReportDataQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeSummaryReportDataQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["accessLevel"] = this.accessLevel;
        data["jurisdictions"] = this.jurisdictions;
        data["categories"] = this.categories;
        data["reportDate"] = this.reportDate;
        data["creationDateRange"] = this.creationDateRange;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetKnowledgeSummaryReportDataQueryResponse {
        const json = this.toJSON();
        let result = new GetKnowledgeSummaryReportDataQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeSummaryReportDataQueryResponse {
    title?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    creationDateRange?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledgeSummaryViewData[] | undefined;
    count?: number;
}

export class GetKnowledgeFileReportDataQueryRequest implements IGetKnowledgeFileReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetKnowledgeFileReportDataQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKnowledgeFileReportDataQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeFileReportDataQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetKnowledgeFileReportDataQueryRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeFileReportDataQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeFileReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class StringInt64KeyValuePair implements IStringInt64KeyValuePair {
    readonly key?: string | undefined;
    readonly value?: number;

    constructor(data?: IStringInt64KeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).key = _data["key"];
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): StringInt64KeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringInt64KeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }

    clone(): StringInt64KeyValuePair {
        const json = this.toJSON();
        let result = new StringInt64KeyValuePair();
        result.init(json);
        return result;
    }
}

export interface IStringInt64KeyValuePair {
    key?: string | undefined;
    value?: number;
}

export class GetKnowledgeFileReportDataQueryResponse implements IGetKnowledgeFileReportDataQueryResponse {
    groupBy?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: StringInt64KeyValuePair[] | undefined;
    count?: number;

    constructor(data?: IGetKnowledgeFileReportDataQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new StringInt64KeyValuePair(item) : <StringInt64KeyValuePair>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupBy = _data["groupBy"];
            this.accessLevel = _data["accessLevel"];
            this.jurisdictions = _data["jurisdictions"];
            this.categories = _data["categories"];
            this.reportDate = _data["reportDate"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StringInt64KeyValuePair.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetKnowledgeFileReportDataQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeFileReportDataQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupBy"] = this.groupBy;
        data["accessLevel"] = this.accessLevel;
        data["jurisdictions"] = this.jurisdictions;
        data["categories"] = this.categories;
        data["reportDate"] = this.reportDate;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetKnowledgeFileReportDataQueryResponse {
        const json = this.toJSON();
        let result = new GetKnowledgeFileReportDataQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeFileReportDataQueryResponse {
    groupBy?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IStringInt64KeyValuePair[] | undefined;
    count?: number;
}

export class GetAllPublicKnowledgeByFilterQueryRequest implements IGetAllPublicKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllPublicKnowledgeByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPublicKnowledgeByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPublicKnowledgeByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllPublicKnowledgeByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllPublicKnowledgeByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllPublicKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllPublicKnowledgeByFilterQueryResponse implements IGetAllPublicKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Knowledge[] | undefined;
    count?: number;

    constructor(data?: IGetAllPublicKnowledgeByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Knowledge(item) : <Knowledge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Knowledge.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllPublicKnowledgeByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPublicKnowledgeByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllPublicKnowledgeByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllPublicKnowledgeByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllPublicKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledge[] | undefined;
    count?: number;
}

export class GetKnowledgeByIdQueryRequest implements IGetKnowledgeByIdQueryRequest {
    knowledgeId?: string | undefined;

    constructor(data?: IGetKnowledgeByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
        }
    }

    static fromJS(data: any): GetKnowledgeByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        return data; 
    }

    clone(): GetKnowledgeByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeByIdQueryRequest {
    knowledgeId?: string | undefined;
}

export class KnowledgeModel implements IKnowledgeModel {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    knowledgeDataTemplateId?: string | undefined;
    templateDataJSON?: string | undefined;
    categoryId?: string;
    documents?: DocumentModel[] | undefined;
    accessLevel?: AccessLevel;
    categoryName?: string | undefined;
    author?: string | undefined;
    authorId?: string | undefined;
    createdDate?: string | undefined;
    modifiedDate?: string | undefined;
    currentlySelectedTemplateJSON?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string;
    status?: KnowledgeStatus;

    constructor(data?: IKnowledgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new DocumentModel(item) : <DocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.knowledgeDataTemplateId = _data["knowledgeDataTemplateId"];
            this.templateDataJSON = _data["templateDataJSON"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentModel.fromJS(item));
            }
            this.accessLevel = _data["accessLevel"];
            this.categoryName = _data["categoryName"];
            this.author = _data["author"];
            this.authorId = _data["authorId"];
            this.createdDate = _data["createdDate"];
            this.modifiedDate = _data["modifiedDate"];
            this.currentlySelectedTemplateJSON = _data["currentlySelectedTemplateJSON"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): KnowledgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["knowledgeDataTemplateId"] = this.knowledgeDataTemplateId;
        data["templateDataJSON"] = this.templateDataJSON;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["accessLevel"] = this.accessLevel;
        data["categoryName"] = this.categoryName;
        data["author"] = this.author;
        data["authorId"] = this.authorId;
        data["createdDate"] = this.createdDate;
        data["modifiedDate"] = this.modifiedDate;
        data["currentlySelectedTemplateJSON"] = this.currentlySelectedTemplateJSON;
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        data["status"] = this.status;
        return data; 
    }

    clone(): KnowledgeModel {
        const json = this.toJSON();
        let result = new KnowledgeModel();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeModel {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    knowledgeDataTemplateId?: string | undefined;
    templateDataJSON?: string | undefined;
    categoryId?: string;
    documents?: IDocumentModel[] | undefined;
    accessLevel?: AccessLevel;
    categoryName?: string | undefined;
    author?: string | undefined;
    authorId?: string | undefined;
    createdDate?: string | undefined;
    modifiedDate?: string | undefined;
    currentlySelectedTemplateJSON?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string;
    status?: KnowledgeStatus;
}

export class GetKnowledgeByIdQueryResponse implements IGetKnowledgeByIdQueryResponse {
    knowledge?: KnowledgeModel | undefined;

    constructor(data?: IGetKnowledgeByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledge = data.knowledge && !(<any>data.knowledge).toJSON ? new KnowledgeModel(data.knowledge) : <KnowledgeModel>this.knowledge; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledge = _data["knowledge"] ? KnowledgeModel.fromJS(_data["knowledge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKnowledgeByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledge"] = this.knowledge ? this.knowledge.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetKnowledgeByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetKnowledgeByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeByIdQueryResponse {
    knowledge?: IKnowledgeModel | undefined;
}

export class GetKnowledgeByNameQueryRequest implements IGetKnowledgeByNameQueryRequest {
    knowledgeName?: string | undefined;

    constructor(data?: IGetKnowledgeByNameQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeName = _data["knowledgeName"];
        }
    }

    static fromJS(data: any): GetKnowledgeByNameQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeByNameQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeName"] = this.knowledgeName;
        return data; 
    }

    clone(): GetKnowledgeByNameQueryRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeByNameQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeByNameQueryRequest {
    knowledgeName?: string | undefined;
}

export class GetKnowledgeByNameQueryResponse implements IGetKnowledgeByNameQueryResponse {
    knowledge?: KnowledgeModel | undefined;

    constructor(data?: IGetKnowledgeByNameQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledge = data.knowledge && !(<any>data.knowledge).toJSON ? new KnowledgeModel(data.knowledge) : <KnowledgeModel>this.knowledge; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledge = _data["knowledge"] ? KnowledgeModel.fromJS(_data["knowledge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKnowledgeByNameQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeByNameQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledge"] = this.knowledge ? this.knowledge.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetKnowledgeByNameQueryResponse {
        const json = this.toJSON();
        let result = new GetKnowledgeByNameQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeByNameQueryResponse {
    knowledge?: IKnowledgeModel | undefined;
}

export class GetKnowledgeContributorReportDataQueryRequest implements IGetKnowledgeContributorReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetKnowledgeContributorReportDataQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKnowledgeContributorReportDataQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeContributorReportDataQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetKnowledgeContributorReportDataQueryRequest {
        const json = this.toJSON();
        let result = new GetKnowledgeContributorReportDataQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeContributorReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class KnowledgeContributorReportModel implements IKnowledgeContributorReportModel {
    count?: number;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;

    constructor(data?: IKnowledgeContributorReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): KnowledgeContributorReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeContributorReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        return data; 
    }

    clone(): KnowledgeContributorReportModel {
        const json = this.toJSON();
        let result = new KnowledgeContributorReportModel();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeContributorReportModel {
    count?: number;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
}

export class GetKnowledgeContributorReportDataQueryResponse implements IGetKnowledgeContributorReportDataQueryResponse {
    title?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    creationDateRange?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: KnowledgeContributorReportModel[] | undefined;
    count?: number;

    constructor(data?: IGetKnowledgeContributorReportDataQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new KnowledgeContributorReportModel(item) : <KnowledgeContributorReportModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.accessLevel = _data["accessLevel"];
            this.jurisdictions = _data["jurisdictions"];
            this.categories = _data["categories"];
            this.reportDate = _data["reportDate"];
            this.creationDateRange = _data["creationDateRange"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KnowledgeContributorReportModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetKnowledgeContributorReportDataQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeContributorReportDataQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["accessLevel"] = this.accessLevel;
        data["jurisdictions"] = this.jurisdictions;
        data["categories"] = this.categories;
        data["reportDate"] = this.reportDate;
        data["creationDateRange"] = this.creationDateRange;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetKnowledgeContributorReportDataQueryResponse {
        const json = this.toJSON();
        let result = new GetKnowledgeContributorReportDataQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetKnowledgeContributorReportDataQueryResponse {
    title?: string | undefined;
    accessLevel?: string | undefined;
    jurisdictions?: string | undefined;
    categories?: string | undefined;
    reportDate?: string;
    creationDateRange?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledgeContributorReportModel[] | undefined;
    count?: number;
}

export class ChangeKnowledgeStatusCommandRequest implements IChangeKnowledgeStatusCommandRequest {
    id?: string | undefined;
    newStatus?: KnowledgeStatus | undefined;

    constructor(data?: IChangeKnowledgeStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newStatus = _data["newStatus"];
        }
    }

    static fromJS(data: any): ChangeKnowledgeStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeKnowledgeStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newStatus"] = this.newStatus;
        return data; 
    }

    clone(): ChangeKnowledgeStatusCommandRequest {
        const json = this.toJSON();
        let result = new ChangeKnowledgeStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeKnowledgeStatusCommandRequest {
    id?: string | undefined;
    newStatus?: KnowledgeStatus | undefined;
}

export class CanUserAccessKnowledgeQueryRequest implements ICanUserAccessKnowledgeQueryRequest {
    knowledgeId?: string | undefined;

    constructor(data?: ICanUserAccessKnowledgeQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
        }
    }

    static fromJS(data: any): CanUserAccessKnowledgeQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CanUserAccessKnowledgeQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        return data; 
    }

    clone(): CanUserAccessKnowledgeQueryRequest {
        const json = this.toJSON();
        let result = new CanUserAccessKnowledgeQueryRequest();
        result.init(json);
        return result;
    }
}

export interface ICanUserAccessKnowledgeQueryRequest {
    knowledgeId?: string | undefined;
}

export class CanUserAccessKnowledgeQueryResponse implements ICanUserAccessKnowledgeQueryResponse {
    canAccess?: boolean;

    constructor(data?: ICanUserAccessKnowledgeQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
        }
    }

    static fromJS(data: any): CanUserAccessKnowledgeQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CanUserAccessKnowledgeQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        return data; 
    }

    clone(): CanUserAccessKnowledgeQueryResponse {
        const json = this.toJSON();
        let result = new CanUserAccessKnowledgeQueryResponse();
        result.init(json);
        return result;
    }
}

export interface ICanUserAccessKnowledgeQueryResponse {
    canAccess?: boolean;
}

export class AddRoleCommandRequest implements IAddRoleCommandRequest {
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    jurisdictionId?: string | undefined;
    status?: RoleStatus | undefined;

    constructor(data?: IAddRoleCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            this.jurisdictionId = _data["jurisdictionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AddRoleCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        data["jurisdictionId"] = this.jurisdictionId;
        data["status"] = this.status;
        return data; 
    }

    clone(): AddRoleCommandRequest {
        const json = this.toJSON();
        let result = new AddRoleCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddRoleCommandRequest {
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    jurisdictionId?: string | undefined;
    status?: RoleStatus | undefined;
}

export class AddRoleCommandResponse implements IAddRoleCommandResponse {
    role?: Role | undefined;

    constructor(data?: IAddRoleCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRoleCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AddRoleCommandResponse {
        const json = this.toJSON();
        let result = new AddRoleCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddRoleCommandResponse {
    role?: IRole | undefined;
}

export class EditRoleCommandRequest implements IEditRoleCommandRequest {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    jurisdictionId?: string | undefined;
    status?: RoleStatus | undefined;

    constructor(data?: IEditRoleCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            this.jurisdictionId = _data["jurisdictionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditRoleCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoleCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        data["jurisdictionId"] = this.jurisdictionId;
        data["status"] = this.status;
        return data; 
    }

    clone(): EditRoleCommandRequest {
        const json = this.toJSON();
        let result = new EditRoleCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditRoleCommandRequest {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    jurisdictionId?: string | undefined;
    status?: RoleStatus | undefined;
}

export class EditRoleCommandResponse implements IEditRoleCommandResponse {
    role?: Role | undefined;

    constructor(data?: IEditRoleCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditRoleCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoleCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EditRoleCommandResponse {
        const json = this.toJSON();
        let result = new EditRoleCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditRoleCommandResponse {
    role?: IRole | undefined;
}

export class RemoveRoleCommandRequest implements IRemoveRoleCommandRequest {
    id?: string;

    constructor(data?: IRemoveRoleCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveRoleCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRoleCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): RemoveRoleCommandRequest {
        const json = this.toJSON();
        let result = new RemoveRoleCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveRoleCommandRequest {
    id?: string;
}

export class RemoveRoleCommandResponse implements IRemoveRoleCommandResponse {

    constructor(data?: IRemoveRoleCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveRoleCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRoleCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): RemoveRoleCommandResponse {
        const json = this.toJSON();
        let result = new RemoveRoleCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveRoleCommandResponse {
}

export class Operation implements IOperation {
    name?: string | undefined;
    isForJurisdiction?: boolean;

    constructor(data?: IOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isForJurisdiction = _data["isForJurisdiction"];
        }
    }

    static fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isForJurisdiction"] = this.isForJurisdiction;
        return data; 
    }

    clone(): Operation {
        const json = this.toJSON();
        let result = new Operation();
        result.init(json);
        return result;
    }
}

export interface IOperation {
    name?: string | undefined;
    isForJurisdiction?: boolean;
}

export class GetOperationsListCommandResponse implements IGetOperationsListCommandResponse {
    operations?: Operation[] | undefined;

    constructor(data?: IGetOperationsListCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.operations) {
                this.operations = [];
                for (let i = 0; i < data.operations.length; i++) {
                    let item = data.operations[i];
                    this.operations[i] = item && !(<any>item).toJSON ? new Operation(item) : <Operation>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(Operation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOperationsListCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperationsListCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetOperationsListCommandResponse {
        const json = this.toJSON();
        let result = new GetOperationsListCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOperationsListCommandResponse {
    operations?: IOperation[] | undefined;
}

export class GetAllRolesByFilterQueryRequest implements IGetAllRolesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllRolesByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllRolesByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRolesByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllRolesByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllRolesByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllRolesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class RoleListView implements IRoleListView {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    status?: RoleStatus;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    creationDate?: string | undefined;
    permissionCount?: number;

    constructor(data?: IRoleListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.creationDate = _data["creationDate"];
            this.permissionCount = _data["permissionCount"];
        }
    }

    static fromJS(data: any): RoleListView {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["creationDate"] = this.creationDate;
        data["permissionCount"] = this.permissionCount;
        return data; 
    }

    clone(): RoleListView {
        const json = this.toJSON();
        let result = new RoleListView();
        result.init(json);
        return result;
    }
}

export interface IRoleListView {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    status?: RoleStatus;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    creationDate?: string | undefined;
    permissionCount?: number;
}

export class GetAllRolesByFilterQueryResponse implements IGetAllRolesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: RoleListView[] | undefined;
    count?: number;

    constructor(data?: IGetAllRolesByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new RoleListView(item) : <RoleListView>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RoleListView.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllRolesByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRolesByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllRolesByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllRolesByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllRolesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IRoleListView[] | undefined;
    count?: number;
}

export class GetRoleByIdQueryRequest implements IGetRoleByIdQueryRequest {
    roleId?: string;

    constructor(data?: IGetRoleByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): GetRoleByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data; 
    }

    clone(): GetRoleByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetRoleByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetRoleByIdQueryRequest {
    roleId?: string;
}

export class RoleDetailsModel implements IRoleDetailsModel {
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    status?: RoleStatus;
    id?: string | undefined;
    readonly jurisdictionId?: string | undefined;

    constructor(data?: IRoleDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            this.status = _data["status"];
            this.id = _data["id"];
            (<any>this).jurisdictionId = _data["jurisdictionId"];
        }
    }

    static fromJS(data: any): RoleDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        data["status"] = this.status;
        data["id"] = this.id;
        data["jurisdictionId"] = this.jurisdictionId;
        return data; 
    }

    clone(): RoleDetailsModel {
        const json = this.toJSON();
        let result = new RoleDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IRoleDetailsModel {
    name?: string | undefined;
    description?: string | undefined;
    operations?: string[] | undefined;
    status?: RoleStatus;
    id?: string | undefined;
    jurisdictionId?: string | undefined;
}

export class GetRoleByIdQueryResponse implements IGetRoleByIdQueryResponse {
    role?: RoleDetailsModel | undefined;

    constructor(data?: IGetRoleByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.role = data.role && !(<any>data.role).toJSON ? new RoleDetailsModel(data.role) : <RoleDetailsModel>this.role; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDetailsModel.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRoleByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetRoleByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetRoleByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRoleByIdQueryResponse {
    role?: IRoleDetailsModel | undefined;
}

export class UnlockUserCommandRequest implements IUnlockUserCommandRequest {
    username?: string | undefined;

    constructor(data?: IUnlockUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): UnlockUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data; 
    }

    clone(): UnlockUserCommandRequest {
        const json = this.toJSON();
        let result = new UnlockUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUnlockUserCommandRequest {
    username?: string | undefined;
}

export class UnlockUserCommandResponse implements IUnlockUserCommandResponse {

    constructor(data?: IUnlockUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UnlockUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): UnlockUserCommandResponse {
        const json = this.toJSON();
        let result = new UnlockUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUnlockUserCommandResponse {
}

export class LoginCommandRequest implements ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }

    clone(): LoginCommandRequest {
        const json = this.toJSON();
        let result = new LoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class SlimUser implements ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    isLocked?: boolean;
    userPreference?: UserPreference | undefined;

    constructor(data?: ISlimUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userPreference = data.userPreference && !(<any>data.userPreference).toJSON ? new UserPreference(data.userPreference) : <UserPreference>this.userPreference; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.isLocked = _data["isLocked"];
            this.userPreference = _data["userPreference"] ? UserPreference.fromJS(_data["userPreference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SlimUser {
        data = typeof data === 'object' ? data : {};
        let result = new SlimUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["isLocked"] = this.isLocked;
        data["userPreference"] = this.userPreference ? this.userPreference.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SlimUser {
        const json = this.toJSON();
        let result = new SlimUser();
        result.init(json);
        return result;
    }
}

export interface ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    isLocked?: boolean;
    userPreference?: IUserPreference | undefined;
}

export class LoginCommandResponse implements ILoginCommandResponse {
    readonly username?: string | undefined;
    readonly fullname?: string | undefined;
    readonly loggedIn?: boolean;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;
    readonly user?: SlimUser | undefined;

    constructor(data?: ILoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).username = _data["username"];
            (<any>this).fullname = _data["fullname"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullname"] = this.fullname;
        data["loggedIn"] = this.loggedIn;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LoginCommandResponse {
        const json = this.toJSON();
        let result = new LoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandResponse {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    user?: ISlimUser | undefined;
}

export class ActivateUserCommandRequest implements IActivateUserCommandRequest {
    token?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;

    constructor(data?: IActivateUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivateUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        return data; 
    }

    clone(): ActivateUserCommandRequest {
        const json = this.toJSON();
        let result = new ActivateUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IActivateUserCommandRequest {
    token?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded?: boolean;
    readonly errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.errors) {
                this.errors = [];
                for (let i = 0; i < data.errors.length; i++) {
                    let item = data.errors[i];
                    this.errors[i] = item && !(<any>item).toJSON ? new IdentityError(item) : <IdentityError>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded?: boolean;
    errors?: IIdentityError[] | undefined;
}

export class ActivateUserCommandResponse implements IActivateUserCommandResponse {
    readonly result?: IdentityResult | undefined;
    readonly user?: SlimUser | undefined;

    constructor(data?: IActivateUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result; 
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivateUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ActivateUserCommandResponse {
        const json = this.toJSON();
        let result = new ActivateUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IActivateUserCommandResponse {
    result?: IIdentityResult | undefined;
    user?: ISlimUser | undefined;
}

export class GetFilteredCountriesQueryRequest implements IGetFilteredCountriesQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredCountriesQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredCountriesQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredCountriesQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredCountriesQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredCountriesQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredCountriesQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetFilteredCountriesQueryResponse implements IGetFilteredCountriesQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Country[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredCountriesQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Country(item) : <Country>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Country.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredCountriesQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredCountriesQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredCountriesQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredCountriesQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredCountriesQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ICountry[] | undefined;
    count?: number;
}

export class GetFilteredJurisdictionsQueryRequest implements IGetFilteredJurisdictionsQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredJurisdictionsQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredJurisdictionsQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredJurisdictionsQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredJurisdictionsQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredJurisdictionsQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredJurisdictionsQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetFilteredJurisdictionsQueryResponse implements IGetFilteredJurisdictionsQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Jurisdiction[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredJurisdictionsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Jurisdiction(item) : <Jurisdiction>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Jurisdiction.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredJurisdictionsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredJurisdictionsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredJurisdictionsQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredJurisdictionsQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredJurisdictionsQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IJurisdiction[] | undefined;
    count?: number;
}

export class GetAllCategoryByFilterQueryRequest implements IGetAllCategoryByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllCategoryByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCategoryByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCategoryByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllCategoryByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllCategoryByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllCategoryByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllCategoryByFilterQueryResponse implements IGetAllCategoryByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: KnowledgeCategory[] | undefined;
    count?: number;

    constructor(data?: IGetAllCategoryByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new KnowledgeCategory(item) : <KnowledgeCategory>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KnowledgeCategory.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllCategoryByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCategoryByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllCategoryByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllCategoryByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllCategoryByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledgeCategory[] | undefined;
    count?: number;
}

export class GetAllUserKnowledgeShareRequestByFilterQueryRequest implements IGetAllUserKnowledgeShareRequestByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUserKnowledgeShareRequestByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUserKnowledgeShareRequestByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserKnowledgeShareRequestByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUserKnowledgeShareRequestByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUserKnowledgeShareRequestByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserKnowledgeShareRequestByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class SlimKnowledgeShare implements ISlimKnowledgeShare {
    id?: string;
    status?: any | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    approvalCount?: any | undefined;
    creationDate?: string | undefined;
    requestorName?: string | undefined;
    description?: string | undefined;
    knowledgeCount?: number | undefined;
    requestedAccessLevel?: AccessLevel | undefined;
    requestorId?: string | undefined;
    expiryDate?: string | undefined;

    constructor(data?: ISlimKnowledgeShare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.approvalCount = _data["approvalCount"];
            this.creationDate = _data["creationDate"];
            this.requestorName = _data["requestorName"];
            this.description = _data["description"];
            this.knowledgeCount = _data["knowledgeCount"];
            this.requestedAccessLevel = _data["requestedAccessLevel"];
            this.requestorId = _data["requestorId"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): SlimKnowledgeShare {
        data = typeof data === 'object' ? data : {};
        let result = new SlimKnowledgeShare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        data["approvalCount"] = this.approvalCount;
        data["creationDate"] = this.creationDate;
        data["requestorName"] = this.requestorName;
        data["description"] = this.description;
        data["knowledgeCount"] = this.knowledgeCount;
        data["requestedAccessLevel"] = this.requestedAccessLevel;
        data["requestorId"] = this.requestorId;
        data["expiryDate"] = this.expiryDate;
        return data; 
    }

    clone(): SlimKnowledgeShare {
        const json = this.toJSON();
        let result = new SlimKnowledgeShare();
        result.init(json);
        return result;
    }
}

export interface ISlimKnowledgeShare {
    id?: string;
    status?: any | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    approvalCount?: any | undefined;
    creationDate?: string | undefined;
    requestorName?: string | undefined;
    description?: string | undefined;
    knowledgeCount?: number | undefined;
    requestedAccessLevel?: AccessLevel | undefined;
    requestorId?: string | undefined;
    expiryDate?: string | undefined;
}

export class GetAllUserKnowledgeShareRequestByFilterQueryResponse implements IGetAllUserKnowledgeShareRequestByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimKnowledgeShare[] | undefined;
    count?: number;

    constructor(data?: IGetAllUserKnowledgeShareRequestByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimKnowledgeShare(item) : <SlimKnowledgeShare>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimKnowledgeShare.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUserKnowledgeShareRequestByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserKnowledgeShareRequestByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUserKnowledgeShareRequestByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUserKnowledgeShareRequestByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserKnowledgeShareRequestByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimKnowledgeShare[] | undefined;
    count?: number;
}

export class GetUserSharedKnowledgeRequestByIdCommandRequest implements IGetUserSharedKnowledgeRequestByIdCommandRequest {
    id?: string;

    constructor(data?: IGetUserSharedKnowledgeRequestByIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserSharedKnowledgeRequestByIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSharedKnowledgeRequestByIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetUserSharedKnowledgeRequestByIdCommandRequest {
        const json = this.toJSON();
        let result = new GetUserSharedKnowledgeRequestByIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserSharedKnowledgeRequestByIdCommandRequest {
    id?: string;
}

export class KnowledgeShareKnowledge implements IKnowledgeShareKnowledge {
    knowledgeShareId?: string;
    knowledgeShare?: KnowledgeShare | undefined;
    knowledgeId?: string;
    knowledge?: Knowledge | undefined;

    constructor(data?: IKnowledgeShareKnowledge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledgeShare = data.knowledgeShare && !(<any>data.knowledgeShare).toJSON ? new KnowledgeShare(data.knowledgeShare) : <KnowledgeShare>this.knowledgeShare; 
            this.knowledge = data.knowledge && !(<any>data.knowledge).toJSON ? new Knowledge(data.knowledge) : <Knowledge>this.knowledge; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeShareId = _data["knowledgeShareId"];
            this.knowledgeShare = _data["knowledgeShare"] ? KnowledgeShare.fromJS(_data["knowledgeShare"]) : <any>undefined;
            this.knowledgeId = _data["knowledgeId"];
            this.knowledge = _data["knowledge"] ? Knowledge.fromJS(_data["knowledge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KnowledgeShareKnowledge {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeShareKnowledge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeShareId"] = this.knowledgeShareId;
        data["knowledgeShare"] = this.knowledgeShare ? this.knowledgeShare.toJSON() : <any>undefined;
        data["knowledgeId"] = this.knowledgeId;
        data["knowledge"] = this.knowledge ? this.knowledge.toJSON() : <any>undefined;
        return data; 
    }

    clone(): KnowledgeShareKnowledge {
        const json = this.toJSON();
        let result = new KnowledgeShareKnowledge();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeShareKnowledge {
    knowledgeShareId?: string;
    knowledgeShare?: IKnowledgeShare | undefined;
    knowledgeId?: string;
    knowledge?: IKnowledge | undefined;
}

export enum KnowledgeShareApprovalType {
    Approved = "Approved",
    Rejected = "Rejected",
}

export class KnowledgeShareApproval implements IKnowledgeShareApproval {
    knowledgeShareId?: string;
    knowledgeShare?: KnowledgeShare | undefined;
    approvalType?: KnowledgeShareApprovalType;
    approverName?: string | undefined;
    approverId?: string | undefined;
    comment?: string | undefined;
    jurisdictionId?: string;
    jurisdiction?: Jurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledgeShareApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledgeShare = data.knowledgeShare && !(<any>data.knowledgeShare).toJSON ? new KnowledgeShare(data.knowledgeShare) : <KnowledgeShare>this.knowledgeShare; 
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeShareId = _data["knowledgeShareId"];
            this.knowledgeShare = _data["knowledgeShare"] ? KnowledgeShare.fromJS(_data["knowledgeShare"]) : <any>undefined;
            this.approvalType = _data["approvalType"];
            this.approverName = _data["approverName"];
            this.approverId = _data["approverId"];
            this.comment = _data["comment"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): KnowledgeShareApproval {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeShareApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeShareId"] = this.knowledgeShareId;
        data["knowledgeShare"] = this.knowledgeShare ? this.knowledgeShare.toJSON() : <any>undefined;
        data["approvalType"] = this.approvalType;
        data["approverName"] = this.approverName;
        data["approverId"] = this.approverId;
        data["comment"] = this.comment;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): KnowledgeShareApproval {
        const json = this.toJSON();
        let result = new KnowledgeShareApproval();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeShareApproval {
    knowledgeShareId?: string;
    knowledgeShare?: IKnowledgeShare | undefined;
    approvalType?: KnowledgeShareApprovalType;
    approverName?: string | undefined;
    approverId?: string | undefined;
    comment?: string | undefined;
    jurisdictionId?: string;
    jurisdiction?: IJurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class KnowledgeShareAccessor implements IKnowledgeShareAccessor {
    userId?: string;
    user?: User | undefined;
    knowledgeShareId?: string;
    knowledgeShare?: KnowledgeShare | undefined;

    constructor(data?: IKnowledgeShareAccessor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.knowledgeShare = data.knowledgeShare && !(<any>data.knowledgeShare).toJSON ? new KnowledgeShare(data.knowledgeShare) : <KnowledgeShare>this.knowledgeShare; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.knowledgeShareId = _data["knowledgeShareId"];
            this.knowledgeShare = _data["knowledgeShare"] ? KnowledgeShare.fromJS(_data["knowledgeShare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KnowledgeShareAccessor {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeShareAccessor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["knowledgeShareId"] = this.knowledgeShareId;
        data["knowledgeShare"] = this.knowledgeShare ? this.knowledgeShare.toJSON() : <any>undefined;
        return data; 
    }

    clone(): KnowledgeShareAccessor {
        const json = this.toJSON();
        let result = new KnowledgeShareAccessor();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeShareAccessor {
    userId?: string;
    user?: IUser | undefined;
    knowledgeShareId?: string;
    knowledgeShare?: IKnowledgeShare | undefined;
}

export enum KnowledgeShareStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
    Expired = "Expired",
}

export class KnowledgeShare implements IKnowledgeShare {
    description?: string | undefined;
    notes?: string | undefined;
    requesterId?: string | undefined;
    requester?: User | undefined;
    startDate?: string | undefined;
    expiryDate?: string | undefined;
    knowledgeShareKnowledges?: KnowledgeShareKnowledge[] | undefined;
    knowledgeShareApprovals?: KnowledgeShareApproval[] | undefined;
    accessors?: KnowledgeShareAccessor[] | undefined;
    requestedAccessLevel?: AccessLevel | undefined;
    knowledgeShareStatus?: KnowledgeShareStatus;
    jurisdictionId?: string;
    jurisdiction?: Jurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IKnowledgeShare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.requester = data.requester && !(<any>data.requester).toJSON ? new User(data.requester) : <User>this.requester; 
            if (data.knowledgeShareKnowledges) {
                this.knowledgeShareKnowledges = [];
                for (let i = 0; i < data.knowledgeShareKnowledges.length; i++) {
                    let item = data.knowledgeShareKnowledges[i];
                    this.knowledgeShareKnowledges[i] = item && !(<any>item).toJSON ? new KnowledgeShareKnowledge(item) : <KnowledgeShareKnowledge>item;
                }
            }
            if (data.knowledgeShareApprovals) {
                this.knowledgeShareApprovals = [];
                for (let i = 0; i < data.knowledgeShareApprovals.length; i++) {
                    let item = data.knowledgeShareApprovals[i];
                    this.knowledgeShareApprovals[i] = item && !(<any>item).toJSON ? new KnowledgeShareApproval(item) : <KnowledgeShareApproval>item;
                }
            }
            if (data.accessors) {
                this.accessors = [];
                for (let i = 0; i < data.accessors.length; i++) {
                    let item = data.accessors[i];
                    this.accessors[i] = item && !(<any>item).toJSON ? new KnowledgeShareAccessor(item) : <KnowledgeShareAccessor>item;
                }
            }
            this.jurisdiction = data.jurisdiction && !(<any>data.jurisdiction).toJSON ? new Jurisdiction(data.jurisdiction) : <Jurisdiction>this.jurisdiction; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.requesterId = _data["requesterId"];
            this.requester = _data["requester"] ? User.fromJS(_data["requester"]) : <any>undefined;
            this.startDate = _data["startDate"];
            this.expiryDate = _data["expiryDate"];
            if (Array.isArray(_data["knowledgeShareKnowledges"])) {
                this.knowledgeShareKnowledges = [] as any;
                for (let item of _data["knowledgeShareKnowledges"])
                    this.knowledgeShareKnowledges!.push(KnowledgeShareKnowledge.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeShareApprovals"])) {
                this.knowledgeShareApprovals = [] as any;
                for (let item of _data["knowledgeShareApprovals"])
                    this.knowledgeShareApprovals!.push(KnowledgeShareApproval.fromJS(item));
            }
            if (Array.isArray(_data["accessors"])) {
                this.accessors = [] as any;
                for (let item of _data["accessors"])
                    this.accessors!.push(KnowledgeShareAccessor.fromJS(item));
            }
            this.requestedAccessLevel = _data["requestedAccessLevel"];
            this.knowledgeShareStatus = _data["knowledgeShareStatus"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdiction = _data["jurisdiction"] ? Jurisdiction.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): KnowledgeShare {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeShare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["requesterId"] = this.requesterId;
        data["requester"] = this.requester ? this.requester.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        data["expiryDate"] = this.expiryDate;
        if (Array.isArray(this.knowledgeShareKnowledges)) {
            data["knowledgeShareKnowledges"] = [];
            for (let item of this.knowledgeShareKnowledges)
                data["knowledgeShareKnowledges"].push(item.toJSON());
        }
        if (Array.isArray(this.knowledgeShareApprovals)) {
            data["knowledgeShareApprovals"] = [];
            for (let item of this.knowledgeShareApprovals)
                data["knowledgeShareApprovals"].push(item.toJSON());
        }
        if (Array.isArray(this.accessors)) {
            data["accessors"] = [];
            for (let item of this.accessors)
                data["accessors"].push(item.toJSON());
        }
        data["requestedAccessLevel"] = this.requestedAccessLevel;
        data["knowledgeShareStatus"] = this.knowledgeShareStatus;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): KnowledgeShare {
        const json = this.toJSON();
        let result = new KnowledgeShare();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeShare {
    description?: string | undefined;
    notes?: string | undefined;
    requesterId?: string | undefined;
    requester?: IUser | undefined;
    startDate?: string | undefined;
    expiryDate?: string | undefined;
    knowledgeShareKnowledges?: IKnowledgeShareKnowledge[] | undefined;
    knowledgeShareApprovals?: IKnowledgeShareApproval[] | undefined;
    accessors?: IKnowledgeShareAccessor[] | undefined;
    requestedAccessLevel?: AccessLevel | undefined;
    knowledgeShareStatus?: KnowledgeShareStatus;
    jurisdictionId?: string;
    jurisdiction?: IJurisdiction | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class GetUserSharedKnowledgeRequestByIdCommandResponse implements IGetUserSharedKnowledgeRequestByIdCommandResponse {
    knowledgeShare?: KnowledgeShare | undefined;

    constructor(data?: IGetUserSharedKnowledgeRequestByIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledgeShare = data.knowledgeShare && !(<any>data.knowledgeShare).toJSON ? new KnowledgeShare(data.knowledgeShare) : <KnowledgeShare>this.knowledgeShare; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeShare = _data["knowledgeShare"] ? KnowledgeShare.fromJS(_data["knowledgeShare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSharedKnowledgeRequestByIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSharedKnowledgeRequestByIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeShare"] = this.knowledgeShare ? this.knowledgeShare.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetUserSharedKnowledgeRequestByIdCommandResponse {
        const json = this.toJSON();
        let result = new GetUserSharedKnowledgeRequestByIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserSharedKnowledgeRequestByIdCommandResponse {
    knowledgeShare?: IKnowledgeShare | undefined;
}

export class AddKnowledgeShareCommandRequest implements IAddKnowledgeShareCommandRequest {
    description?: string | undefined;
    notes?: string | undefined;
    requesterId?: string | undefined;
    jurisdictionId?: string | undefined;
    startDate?: string | undefined;
    expiryDate?: string | undefined;
    accessors?: string[] | undefined;
    knowledges?: string[] | undefined;
    requestedAccessLevel?: AccessLevel | undefined;

    constructor(data?: IAddKnowledgeShareCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.requesterId = _data["requesterId"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.startDate = _data["startDate"];
            this.expiryDate = _data["expiryDate"];
            if (Array.isArray(_data["accessors"])) {
                this.accessors = [] as any;
                for (let item of _data["accessors"])
                    this.accessors!.push(item);
            }
            if (Array.isArray(_data["knowledges"])) {
                this.knowledges = [] as any;
                for (let item of _data["knowledges"])
                    this.knowledges!.push(item);
            }
            this.requestedAccessLevel = _data["requestedAccessLevel"];
        }
    }

    static fromJS(data: any): AddKnowledgeShareCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddKnowledgeShareCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["requesterId"] = this.requesterId;
        data["jurisdictionId"] = this.jurisdictionId;
        data["startDate"] = this.startDate;
        data["expiryDate"] = this.expiryDate;
        if (Array.isArray(this.accessors)) {
            data["accessors"] = [];
            for (let item of this.accessors)
                data["accessors"].push(item);
        }
        if (Array.isArray(this.knowledges)) {
            data["knowledges"] = [];
            for (let item of this.knowledges)
                data["knowledges"].push(item);
        }
        data["requestedAccessLevel"] = this.requestedAccessLevel;
        return data; 
    }

    clone(): AddKnowledgeShareCommandRequest {
        const json = this.toJSON();
        let result = new AddKnowledgeShareCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddKnowledgeShareCommandRequest {
    description?: string | undefined;
    notes?: string | undefined;
    requesterId?: string | undefined;
    jurisdictionId?: string | undefined;
    startDate?: string | undefined;
    expiryDate?: string | undefined;
    accessors?: string[] | undefined;
    knowledges?: string[] | undefined;
    requestedAccessLevel?: AccessLevel | undefined;
}

export class AddKnowledgeShareCommandResponse implements IAddKnowledgeShareCommandResponse {

    constructor(data?: IAddKnowledgeShareCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddKnowledgeShareCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKnowledgeShareCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): AddKnowledgeShareCommandResponse {
        const json = this.toJSON();
        let result = new AddKnowledgeShareCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddKnowledgeShareCommandResponse {
}

export class ApproveKnowledgeShareCommandRequest implements IApproveKnowledgeShareCommandRequest {
    id?: string;
    comment?: string | undefined;

    constructor(data?: IApproveKnowledgeShareCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ApproveKnowledgeShareCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveKnowledgeShareCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): ApproveKnowledgeShareCommandRequest {
        const json = this.toJSON();
        let result = new ApproveKnowledgeShareCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IApproveKnowledgeShareCommandRequest {
    id?: string;
    comment?: string | undefined;
}

export class ApproveKnowledgeShareCommandResponse implements IApproveKnowledgeShareCommandResponse {
    knowledgeShare?: KnowledgeShare | undefined;

    constructor(data?: IApproveKnowledgeShareCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.knowledgeShare = data.knowledgeShare && !(<any>data.knowledgeShare).toJSON ? new KnowledgeShare(data.knowledgeShare) : <KnowledgeShare>this.knowledgeShare; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeShare = _data["knowledgeShare"] ? KnowledgeShare.fromJS(_data["knowledgeShare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApproveKnowledgeShareCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveKnowledgeShareCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeShare"] = this.knowledgeShare ? this.knowledgeShare.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ApproveKnowledgeShareCommandResponse {
        const json = this.toJSON();
        let result = new ApproveKnowledgeShareCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IApproveKnowledgeShareCommandResponse {
    knowledgeShare?: IKnowledgeShare | undefined;
}

export class RejectKnowledgeShareCommandRequest implements IRejectKnowledgeShareCommandRequest {
    id?: string;
    comment?: string | undefined;

    constructor(data?: IRejectKnowledgeShareCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RejectKnowledgeShareCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectKnowledgeShareCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): RejectKnowledgeShareCommandRequest {
        const json = this.toJSON();
        let result = new RejectKnowledgeShareCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRejectKnowledgeShareCommandRequest {
    id?: string;
    comment?: string | undefined;
}

export class RejectKnowledgeShareCommandResponse implements IRejectKnowledgeShareCommandResponse {

    constructor(data?: IRejectKnowledgeShareCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RejectKnowledgeShareCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectKnowledgeShareCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): RejectKnowledgeShareCommandResponse {
        const json = this.toJSON();
        let result = new RejectKnowledgeShareCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRejectKnowledgeShareCommandResponse {
}

export class GetAllSharedKnowledgeByFilterQueryRequest implements IGetAllSharedKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllSharedKnowledgeByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllSharedKnowledgeByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSharedKnowledgeByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllSharedKnowledgeByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllSharedKnowledgeByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllSharedKnowledgeByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllSharedKnowledgeByFilterQueryResponse implements IGetAllSharedKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Knowledge[] | undefined;
    count?: number;

    constructor(data?: IGetAllSharedKnowledgeByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Knowledge(item) : <Knowledge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Knowledge.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllSharedKnowledgeByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSharedKnowledgeByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllSharedKnowledgeByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllSharedKnowledgeByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllSharedKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledge[] | undefined;
    count?: number;
}

export class GetAllUsersByFilterQueryRequest implements IGetAllUsersByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUsersByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUsersByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUsersByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUsersByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllUsersByFilterQueryResponse implements IGetAllUsersByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimUser[] | undefined;
    count?: number;

    constructor(data?: IGetAllUsersByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimUser(item) : <SlimUser>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimUser.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUsersByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUsersByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUsersByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimUser[] | undefined;
    count?: number;
}

export class GetAllUserRegistrationByFilterQueryRequest implements IGetAllUserRegistrationByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUserRegistrationByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUserRegistrationByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserRegistrationByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUserRegistrationByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUserRegistrationByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserRegistrationByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum RegistrationStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export class SlimRegistration implements ISlimRegistration {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: RegistrationStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: string[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    isLocked?: boolean;
    userPreference?: UserPreference | undefined;
    approvalCount?: number | undefined;
    creationDate?: string | undefined;

    constructor(data?: ISlimRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userPreference = data.userPreference && !(<any>data.userPreference).toJSON ? new UserPreference(data.userPreference) : <UserPreference>this.userPreference; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.isLocked = _data["isLocked"];
            this.userPreference = _data["userPreference"] ? UserPreference.fromJS(_data["userPreference"]) : <any>undefined;
            this.approvalCount = _data["approvalCount"];
            this.creationDate = _data["creationDate"];
        }
    }

    static fromJS(data: any): SlimRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new SlimRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["isLocked"] = this.isLocked;
        data["userPreference"] = this.userPreference ? this.userPreference.toJSON() : <any>undefined;
        data["approvalCount"] = this.approvalCount;
        data["creationDate"] = this.creationDate;
        return data; 
    }

    clone(): SlimRegistration {
        const json = this.toJSON();
        let result = new SlimRegistration();
        result.init(json);
        return result;
    }
}

export interface ISlimRegistration {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: RegistrationStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: string[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    isLocked?: boolean;
    userPreference?: IUserPreference | undefined;
    approvalCount?: number | undefined;
    creationDate?: string | undefined;
}

export class GetAllUserRegistrationByFilterQueryResponse implements IGetAllUserRegistrationByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimRegistration[] | undefined;
    count?: number;

    constructor(data?: IGetAllUserRegistrationByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimRegistration(item) : <SlimRegistration>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimRegistration.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUserRegistrationByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserRegistrationByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUserRegistrationByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUserRegistrationByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserRegistrationByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimRegistration[] | undefined;
    count?: number;
}

export class GetAllUsersReportDataQueryRequest implements IGetAllUsersReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUsersReportDataQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUsersReportDataQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersReportDataQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUsersReportDataQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUsersReportDataQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersReportDataQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllUsersReportDataQueryResponse implements IGetAllUsersReportDataQueryResponse {
    status?: string | undefined;
    jurisdiction?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimUser[] | undefined;
    count?: number;

    constructor(data?: IGetAllUsersReportDataQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimUser(item) : <SlimUser>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.jurisdiction = _data["jurisdiction"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimUser.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUsersReportDataQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersReportDataQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["jurisdiction"] = this.jurisdiction;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUsersReportDataQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUsersReportDataQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUsersReportDataQueryResponse {
    status?: string | undefined;
    jurisdiction?: string | undefined;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimUser[] | undefined;
    count?: number;
}

export class GetUserByIdQueryRequest implements IGetUserByIdQueryRequest {
    id?: string;

    constructor(data?: IGetUserByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetUserByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetUserByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdQueryRequest {
    id?: string;
}

export class GetUserByIdModel implements IGetUserByIdModel {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IGetUserByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstName = _data["firstName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.lastName = _data["lastName"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): GetUserByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstName"] = this.firstName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["lastName"] = this.lastName;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }

    clone(): GetUserByIdModel {
        const json = this.toJSON();
        let result = new GetUserByIdModel();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdModel {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    phoneNumber?: string | undefined;
}

export class UserClaim implements IUserClaim {
    id?: number;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id?: number;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userId?: string;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class GetUserByIdQueryResponse implements IGetUserByIdQueryResponse {
    user?: GetUserByIdModel | undefined;
    claims?: UserClaim[] | undefined;

    constructor(data?: IGetUserByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new GetUserByIdModel(data.user) : <GetUserByIdModel>this.user; 
            if (data.claims) {
                this.claims = [];
                for (let i = 0; i < data.claims.length; i++) {
                    let item = data.claims[i];
                    this.claims[i] = item && !(<any>item).toJSON ? new UserClaim(item) : <UserClaim>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? GetUserByIdModel.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetUserByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetUserByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdQueryResponse {
    user?: IGetUserByIdModel | undefined;
    claims?: IUserClaim[] | undefined;
}

export class GetUserRegistrationByIdQueryRequest implements IGetUserRegistrationByIdQueryRequest {
    id?: string;

    constructor(data?: IGetUserRegistrationByIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserRegistrationByIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRegistrationByIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetUserRegistrationByIdQueryRequest {
        const json = this.toJSON();
        let result = new GetUserRegistrationByIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserRegistrationByIdQueryRequest {
    id?: string;
}

export enum RegistrationApprovalType {
    Approved = "Approved",
    Rejected = "Rejected",
}

export class UserRegistrationApprovalModel implements IUserRegistrationApprovalModel {
    approvalType?: RegistrationApprovalType;
    approverName?: string | undefined;
    approverId?: string | undefined;
    comment?: string | undefined;
    creationDate?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IUserRegistrationApprovalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalType = _data["approvalType"];
            this.approverName = _data["approverName"];
            this.approverId = _data["approverId"];
            this.comment = _data["comment"];
            this.creationDate = _data["creationDate"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRegistrationApprovalModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegistrationApprovalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalType"] = this.approvalType;
        data["approverName"] = this.approverName;
        data["approverId"] = this.approverId;
        data["comment"] = this.comment;
        data["creationDate"] = this.creationDate;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): UserRegistrationApprovalModel {
        const json = this.toJSON();
        let result = new UserRegistrationApprovalModel();
        result.init(json);
        return result;
    }
}

export interface IUserRegistrationApprovalModel {
    approvalType?: RegistrationApprovalType;
    approverName?: string | undefined;
    approverId?: string | undefined;
    comment?: string | undefined;
    creationDate?: string | undefined;
    roles?: string[] | undefined;
}

export class GetUserRegistrationByIdModel implements IGetUserRegistrationByIdModel {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: RegistrationStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    approvals?: UserRegistrationApprovalModel[] | undefined;
    department?: string | undefined;

    constructor(data?: IGetUserRegistrationByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.approvals) {
                this.approvals = [];
                for (let i = 0; i < data.approvals.length; i++) {
                    let item = data.approvals[i];
                    this.approvals[i] = item && !(<any>item).toJSON ? new UserRegistrationApprovalModel(item) : <UserRegistrationApprovalModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstName = _data["firstName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.lastName = _data["lastName"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(UserRegistrationApprovalModel.fromJS(item));
            }
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): GetUserRegistrationByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRegistrationByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstName"] = this.firstName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["lastName"] = this.lastName;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        data["department"] = this.department;
        return data; 
    }

    clone(): GetUserRegistrationByIdModel {
        const json = this.toJSON();
        let result = new GetUserRegistrationByIdModel();
        result.init(json);
        return result;
    }
}

export interface IGetUserRegistrationByIdModel {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: RegistrationStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleIds?: string[] | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    approvals?: IUserRegistrationApprovalModel[] | undefined;
    department?: string | undefined;
}

export class GetUserRegistrationByIdQueryResponse implements IGetUserRegistrationByIdQueryResponse {
    user?: GetUserRegistrationByIdModel | undefined;

    constructor(data?: IGetUserRegistrationByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new GetUserRegistrationByIdModel(data.user) : <GetUserRegistrationByIdModel>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? GetUserRegistrationByIdModel.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserRegistrationByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRegistrationByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetUserRegistrationByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetUserRegistrationByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserRegistrationByIdQueryResponse {
    user?: IGetUserRegistrationByIdModel | undefined;
}

export class ApproveUserRegistrationCommandRequest implements IApproveUserRegistrationCommandRequest {
    id?: string;
    comment?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IApproveUserRegistrationCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveUserRegistrationCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveUserRegistrationCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): ApproveUserRegistrationCommandRequest {
        const json = this.toJSON();
        let result = new ApproveUserRegistrationCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IApproveUserRegistrationCommandRequest {
    id?: string;
    comment?: string | undefined;
    roles?: string[] | undefined;
}

export class ApproveUserRegistrationCommandResponse implements IApproveUserRegistrationCommandResponse {
    result?: IdentityResult | undefined;
    newUser?: SlimUser | undefined;

    constructor(data?: IApproveUserRegistrationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result; 
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApproveUserRegistrationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveUserRegistrationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ApproveUserRegistrationCommandResponse {
        const json = this.toJSON();
        let result = new ApproveUserRegistrationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IApproveUserRegistrationCommandResponse {
    result?: IIdentityResult | undefined;
    newUser?: ISlimUser | undefined;
}

export class RejectUserRegistrationCommandRequest implements IRejectUserRegistrationCommandRequest {
    id?: string;
    comment?: string | undefined;

    constructor(data?: IRejectUserRegistrationCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RejectUserRegistrationCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectUserRegistrationCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): RejectUserRegistrationCommandRequest {
        const json = this.toJSON();
        let result = new RejectUserRegistrationCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRejectUserRegistrationCommandRequest {
    id?: string;
    comment?: string | undefined;
}

export class RejectUserRegistrationCommandResponse implements IRejectUserRegistrationCommandResponse {

    constructor(data?: IRejectUserRegistrationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RejectUserRegistrationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectUserRegistrationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): RejectUserRegistrationCommandResponse {
        const json = this.toJSON();
        let result = new RejectUserRegistrationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRejectUserRegistrationCommandResponse {
}

export class ChangeUserStatusCommandRequest implements IChangeUserStatusCommandRequest {
    enable?: boolean;
    id?: string | undefined;

    constructor(data?: IChangeUserStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChangeUserStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["id"] = this.id;
        return data; 
    }

    clone(): ChangeUserStatusCommandRequest {
        const json = this.toJSON();
        let result = new ChangeUserStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeUserStatusCommandRequest {
    enable?: boolean;
    id?: string | undefined;
}

export class EditUserCommandRequest implements IEditUserCommandRequest {
    id?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    dateOfBirth?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    status?: UserStatus;

    constructor(data?: IEditUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmailAddress = _data["confirmEmailAddress"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
            this.taxIdNumber = _data["taxIdNumber"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmailAddress"] = this.confirmEmailAddress;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        data["taxIdNumber"] = this.taxIdNumber;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["dateOfBirth"] = this.dateOfBirth;
        data["jurisdictionId"] = this.jurisdictionId;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }

    clone(): EditUserCommandRequest {
        const json = this.toJSON();
        let result = new EditUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditUserCommandRequest {
    id?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmailAddress?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
    taxIdNumber?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    dateOfBirth?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    status?: UserStatus;
}

export class EditUserCommandResponse implements IEditUserCommandResponse {
    readonly user?: SlimUser | undefined;

    constructor(data?: IEditUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EditUserCommandResponse {
        const json = this.toJSON();
        let result = new EditUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditUserCommandResponse {
    user?: ISlimUser | undefined;
}

export class RegisterUserCommandRequest implements IRegisterUserCommandRequest {
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    department?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IRegisterUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.department = _data["department"];
            this.emailAddress = _data["emailAddress"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RegisterUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["department"] = this.department;
        data["emailAddress"] = this.emailAddress;
        data["jurisdictionId"] = this.jurisdictionId;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        return data; 
    }

    clone(): RegisterUserCommandRequest {
        const json = this.toJSON();
        let result = new RegisterUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterUserCommandRequest {
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    department?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
}

export class RegisterUserCommandResponse implements IRegisterUserCommandResponse {
    readonly result?: IdentityResult | undefined;
    newUser?: SlimUser | undefined;

    constructor(data?: IRegisterUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result; 
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegisterUserCommandResponse {
        const json = this.toJSON();
        let result = new RegisterUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterUserCommandResponse {
    result?: IIdentityResult | undefined;
    newUser?: ISlimUser | undefined;
}

export class ResendConfirmationEmailCommandRequest implements IResendConfirmationEmailCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IResendConfirmationEmailCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ResendConfirmationEmailCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendConfirmationEmailCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): ResendConfirmationEmailCommandRequest {
        const json = this.toJSON();
        let result = new ResendConfirmationEmailCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResendConfirmationEmailCommandRequest {
    emailAddress?: string | undefined;
}

export class ResendConfirmationEmailCommandResponse implements IResendConfirmationEmailCommandResponse {

    constructor(data?: IResendConfirmationEmailCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResendConfirmationEmailCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResendConfirmationEmailCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): ResendConfirmationEmailCommandResponse {
        const json = this.toJSON();
        let result = new ResendConfirmationEmailCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResendConfirmationEmailCommandResponse {
}

export class RemoveUserCommandRequest implements IRemoveUserCommandRequest {
    id?: string;

    constructor(data?: IRemoveUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoveUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): RemoveUserCommandRequest {
        const json = this.toJSON();
        let result = new RemoveUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveUserCommandRequest {
    id?: string;
}

export class RemoveUserCommandResponse implements IRemoveUserCommandResponse {

    constructor(data?: IRemoveUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): RemoveUserCommandResponse {
        const json = this.toJSON();
        let result = new RemoveUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveUserCommandResponse {
}

export class AddUserCommandRequest implements IAddUserCommandRequest {
    id?: string;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IAddUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["jurisdictionId"] = this.jurisdictionId;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): AddUserCommandRequest {
        const json = this.toJSON();
        let result = new AddUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddUserCommandRequest {
    id?: string;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    jurisdictionId?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
}

export class AddUserCommandResponse implements IAddUserCommandResponse {
    readonly result?: IdentityResult | undefined;
    newUser?: SlimUser | undefined;

    constructor(data?: IAddUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result; 
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AddUserCommandResponse {
        const json = this.toJSON();
        let result = new AddUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddUserCommandResponse {
    result?: IIdentityResult | undefined;
    newUser?: ISlimUser | undefined;
}

export class GetAllUserInfoForPublicByFilterQueryRequest implements IGetAllUserInfoForPublicByFilterQueryRequest {
    onlyInSameJurisdiction?: boolean;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUserInfoForPublicByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onlyInSameJurisdiction = _data["onlyInSameJurisdiction"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUserInfoForPublicByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserInfoForPublicByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyInSameJurisdiction"] = this.onlyInSameJurisdiction;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUserInfoForPublicByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUserInfoForPublicByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserInfoForPublicByFilterQueryRequest {
    onlyInSameJurisdiction?: boolean;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class UserInfoModel implements IUserInfoModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;

    constructor(data?: IUserInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
        }
    }

    static fromJS(data: any): UserInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        return data; 
    }

    clone(): UserInfoModel {
        const json = this.toJSON();
        let result = new UserInfoModel();
        result.init(json);
        return result;
    }
}

export interface IUserInfoModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
}

export class GetAllUserInfoForPublicByFilterQueryResponse implements IGetAllUserInfoForPublicByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: UserInfoModel[] | undefined;
    count?: number;

    constructor(data?: IGetAllUserInfoForPublicByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new UserInfoModel(item) : <UserInfoModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserInfoModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUserInfoForPublicByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserInfoForPublicByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUserInfoForPublicByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUserInfoForPublicByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserInfoForPublicByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IUserInfoModel[] | undefined;
    count?: number;
}

export class GetAllRoleInfosForPublicByFilterQueryRequest implements IGetAllRoleInfosForPublicByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllRoleInfosForPublicByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllRoleInfosForPublicByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRoleInfosForPublicByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllRoleInfosForPublicByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllRoleInfosForPublicByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllRoleInfosForPublicByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAllRoleInfosForPublicByFilterQueryResponse implements IGetAllRoleInfosForPublicByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: RoleListView[] | undefined;
    count?: number;

    constructor(data?: IGetAllRoleInfosForPublicByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new RoleListView(item) : <RoleListView>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RoleListView.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllRoleInfosForPublicByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRoleInfosForPublicByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllRoleInfosForPublicByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllRoleInfosForPublicByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllRoleInfosForPublicByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IRoleListView[] | undefined;
    count?: number;
}

export class GenerateEnabledUsersCsvCommandRequest implements IGenerateEnabledUsersCsvCommandRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGenerateEnabledUsersCsvCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateEnabledUsersCsvCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateEnabledUsersCsvCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GenerateEnabledUsersCsvCommandRequest {
        const json = this.toJSON();
        let result = new GenerateEnabledUsersCsvCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGenerateEnabledUsersCsvCommandRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GenerateEnabledUsersCsvCommandResponse implements IGenerateEnabledUsersCsvCommandResponse {
    fileStream?: Stream | undefined;
    fileName?: string | undefined;

    constructor(data?: IGenerateEnabledUsersCsvCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.fileStream = data.fileStream && !(<any>data.fileStream).toJSON ? new Stream(data.fileStream) : <Stream>this.fileStream; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileStream = _data["fileStream"] ? Stream.fromJS(_data["fileStream"]) : <any>undefined;
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): GenerateEnabledUsersCsvCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateEnabledUsersCsvCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileStream"] = this.fileStream ? this.fileStream.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        return data; 
    }

    clone(): GenerateEnabledUsersCsvCommandResponse {
        const json = this.toJSON();
        let result = new GenerateEnabledUsersCsvCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGenerateEnabledUsersCsvCommandResponse {
    fileStream?: IStream | undefined;
    fileName?: string | undefined;
}

export class GetUserPreferenceCommandRequest implements IGetUserPreferenceCommandRequest {

    constructor(data?: IGetUserPreferenceCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserPreferenceCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPreferenceCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetUserPreferenceCommandRequest {
        const json = this.toJSON();
        let result = new GetUserPreferenceCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserPreferenceCommandRequest {
}

export class GetUserPreferenceCommandResponse implements IGetUserPreferenceCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;

    constructor(data?: IGetUserPreferenceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPreferenceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPreferenceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        return data; 
    }

    clone(): GetUserPreferenceCommandResponse {
        const json = this.toJSON();
        let result = new GetUserPreferenceCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserPreferenceCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
}

export class UpsertUserPreferenceCommandRequest implements IUpsertUserPreferenceCommandRequest {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;

    constructor(data?: IUpsertUserPreferenceCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertUserPreferenceCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserPreferenceCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        return data; 
    }

    clone(): UpsertUserPreferenceCommandRequest {
        const json = this.toJSON();
        let result = new UpsertUserPreferenceCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpsertUserPreferenceCommandRequest {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
}

export class UpsertUserPreferenceCommandResponse implements IUpsertUserPreferenceCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;

    constructor(data?: IUpsertUserPreferenceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertUserPreferenceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserPreferenceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        return data; 
    }

    clone(): UpsertUserPreferenceCommandResponse {
        const json = this.toJSON();
        let result = new UpsertUserPreferenceCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpsertUserPreferenceCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
}

export class PinKnowledgeCommandRequest implements IPinKnowledgeCommandRequest {
    knowledgeId?: string | undefined;

    constructor(data?: IPinKnowledgeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
        }
    }

    static fromJS(data: any): PinKnowledgeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PinKnowledgeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        return data; 
    }

    clone(): PinKnowledgeCommandRequest {
        const json = this.toJSON();
        let result = new PinKnowledgeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IPinKnowledgeCommandRequest {
    knowledgeId?: string | undefined;
}

export class PinKnowledgeCommandResponse implements IPinKnowledgeCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;

    constructor(data?: IPinKnowledgeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
        }
    }

    static fromJS(data: any): PinKnowledgeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PinKnowledgeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        return data; 
    }

    clone(): PinKnowledgeCommandResponse {
        const json = this.toJSON();
        let result = new PinKnowledgeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IPinKnowledgeCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
}

export class UnPinKnowledgeCommandRequest implements IUnPinKnowledgeCommandRequest {
    knowledgeId?: string | undefined;

    constructor(data?: IUnPinKnowledgeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeId = _data["knowledgeId"];
        }
    }

    static fromJS(data: any): UnPinKnowledgeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnPinKnowledgeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeId"] = this.knowledgeId;
        return data; 
    }

    clone(): UnPinKnowledgeCommandRequest {
        const json = this.toJSON();
        let result = new UnPinKnowledgeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUnPinKnowledgeCommandRequest {
    knowledgeId?: string | undefined;
}

export class UnPinKnowledgeCommandResponse implements IUnPinKnowledgeCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;

    constructor(data?: IUnPinKnowledgeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["recentlyAddedKnowledgeCategories"])) {
                this.recentlyAddedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyAddedKnowledgeCategories"])
                    this.recentlyAddedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["recentlyModifiedKnowledgeCategories"])) {
                this.recentlyModifiedKnowledgeCategories = [] as any;
                for (let item of _data["recentlyModifiedKnowledgeCategories"])
                    this.recentlyModifiedKnowledgeCategories!.push(item);
            }
            if (Array.isArray(_data["pinnedKnowledge"])) {
                this.pinnedKnowledge = [] as any;
                for (let item of _data["pinnedKnowledge"])
                    this.pinnedKnowledge!.push(item);
            }
        }
    }

    static fromJS(data: any): UnPinKnowledgeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnPinKnowledgeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.recentlyAddedKnowledgeCategories)) {
            data["recentlyAddedKnowledgeCategories"] = [];
            for (let item of this.recentlyAddedKnowledgeCategories)
                data["recentlyAddedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.recentlyModifiedKnowledgeCategories)) {
            data["recentlyModifiedKnowledgeCategories"] = [];
            for (let item of this.recentlyModifiedKnowledgeCategories)
                data["recentlyModifiedKnowledgeCategories"].push(item);
        }
        if (Array.isArray(this.pinnedKnowledge)) {
            data["pinnedKnowledge"] = [];
            for (let item of this.pinnedKnowledge)
                data["pinnedKnowledge"].push(item);
        }
        return data; 
    }

    clone(): UnPinKnowledgeCommandResponse {
        const json = this.toJSON();
        let result = new UnPinKnowledgeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUnPinKnowledgeCommandResponse {
    userId?: string | undefined;
    recentlyAddedKnowledgeCategories?: string[] | undefined;
    recentlyModifiedKnowledgeCategories?: string[] | undefined;
    pinnedKnowledge?: string[] | undefined;
}

export enum UserPreferenceListType {
    RecentlyAdded = "RecentlyAdded",
    RecentlyModified = "RecentlyModified",
}

export class GetMyRecentKnowledgeByFilterQueryRequest implements IGetMyRecentKnowledgeByFilterQueryRequest {
    typeOfRecentList?: UserPreferenceListType;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetMyRecentKnowledgeByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfRecentList = _data["typeOfRecentList"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyRecentKnowledgeByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRecentKnowledgeByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfRecentList"] = this.typeOfRecentList;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMyRecentKnowledgeByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetMyRecentKnowledgeByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMyRecentKnowledgeByFilterQueryRequest {
    typeOfRecentList?: UserPreferenceListType;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetMyRecentKnowledgeByFilterQueryResponse implements IGetMyRecentKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Knowledge[] | undefined;
    count?: number;

    constructor(data?: IGetMyRecentKnowledgeByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Knowledge(item) : <Knowledge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Knowledge.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMyRecentKnowledgeByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRecentKnowledgeByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetMyRecentKnowledgeByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetMyRecentKnowledgeByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyRecentKnowledgeByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledge[] | undefined;
    count?: number;
}

export class GetMyPinnedKnowledgesByFilterQueryRequest implements IGetMyPinnedKnowledgesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetMyPinnedKnowledgesByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyPinnedKnowledgesByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyPinnedKnowledgesByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMyPinnedKnowledgesByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetMyPinnedKnowledgesByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMyPinnedKnowledgesByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetMyPinnedKnowledgesByFilterQueryResponse implements IGetMyPinnedKnowledgesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: Knowledge[] | undefined;
    count?: number;

    constructor(data?: IGetMyPinnedKnowledgesByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Knowledge(item) : <Knowledge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Knowledge.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMyPinnedKnowledgesByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyPinnedKnowledgesByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetMyPinnedKnowledgesByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetMyPinnedKnowledgesByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyPinnedKnowledgesByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IKnowledge[] | undefined;
    count?: number;
}

export class RequestPasswordResetCommandRequest implements IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IRequestPasswordResetCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): RequestPasswordResetCommandRequest {
        const json = this.toJSON();
        let result = new RequestPasswordResetCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;
}

export class ResetPasswordCommandRequest implements IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;

    constructor(data?: IResetPasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        return data; 
    }

    clone(): ResetPasswordCommandRequest {
        const json = this.toJSON();
        let result = new ResetPasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
}

export class ChangePasswordCommandRequest implements IChangePasswordCommandRequest {
    emailAddress?: string | undefined;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordCommandRequest {
        const json = this.toJSON();
        let result = new ChangePasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordCommandRequest {
    emailAddress?: string | undefined;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class GetMyUserProfileQueryResponse implements IGetMyUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    userName?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;

    constructor(data?: IGetMyUserProfileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.imageUrl = _data["imageUrl"];
            this.userName = _data["userName"];
            this.department = _data["department"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.otherPhoneNumberType = _data["otherPhoneNumberType"];
        }
    }

    static fromJS(data: any): GetMyUserProfileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyUserProfileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["imageUrl"] = this.imageUrl;
        data["userName"] = this.userName;
        data["department"] = this.department;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        return data; 
    }

    clone(): GetMyUserProfileQueryResponse {
        const json = this.toJSON();
        let result = new GetMyUserProfileQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    userName?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
}

export class GetUserProfileQueryRequest implements IGetUserProfileQueryRequest {
    userNameOrId?: string | undefined;

    constructor(data?: IGetUserProfileQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrId = _data["userNameOrId"];
        }
    }

    static fromJS(data: any): GetUserProfileQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrId"] = this.userNameOrId;
        return data; 
    }

    clone(): GetUserProfileQueryRequest {
        const json = this.toJSON();
        let result = new GetUserProfileQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserProfileQueryRequest {
    userNameOrId?: string | undefined;
}

export class GetUserProfileQueryResponse implements IGetUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    department?: string | undefined;
    otherPhoneNumberType?: string | undefined;
    otherPhoneNumber?: string | undefined;

    constructor(data?: IGetUserProfileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.userName = _data["userName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.imageUrl = _data["imageUrl"];
            this.department = _data["department"];
            this.otherPhoneNumberType = _data["otherPhoneNumberType"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
        }
    }

    static fromJS(data: any): GetUserProfileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["userName"] = this.userName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["imageUrl"] = this.imageUrl;
        data["department"] = this.department;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        return data; 
    }

    clone(): GetUserProfileQueryResponse {
        const json = this.toJSON();
        let result = new GetUserProfileQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    department?: string | undefined;
    otherPhoneNumberType?: string | undefined;
    otherPhoneNumber?: string | undefined;
}

export class EditUserProfileCommandRequest implements IEditUserProfileCommandRequest {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;

    constructor(data?: IEditUserProfileCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.department = _data["department"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.otherPhoneNumberType = _data["otherPhoneNumberType"];
        }
    }

    static fromJS(data: any): EditUserProfileCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserProfileCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["department"] = this.department;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        return data; 
    }

    clone(): EditUserProfileCommandRequest {
        const json = this.toJSON();
        let result = new EditUserProfileCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditUserProfileCommandRequest {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
}

export class EditUserProfileCommandResponse implements IEditUserProfileCommandResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    readonly department?: string | undefined;
    readonly otherPhoneNumber?: string | undefined;
    readonly otherPhoneNumberType?: string | undefined;

    constructor(data?: IEditUserProfileCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.userName = _data["userName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.imageUrl = _data["imageUrl"];
            (<any>this).department = _data["department"];
            (<any>this).otherPhoneNumber = _data["otherPhoneNumber"];
            (<any>this).otherPhoneNumberType = _data["otherPhoneNumberType"];
        }
    }

    static fromJS(data: any): EditUserProfileCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserProfileCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["userName"] = this.userName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["imageUrl"] = this.imageUrl;
        data["department"] = this.department;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        return data; 
    }

    clone(): EditUserProfileCommandResponse {
        const json = this.toJSON();
        let result = new EditUserProfileCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditUserProfileCommandResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    imageUrl?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
}

export class GetAllUserProfileByFilterQueryRequest implements IGetAllUserProfileByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllUserProfileByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUserProfileByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserProfileByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllUserProfileByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllUserProfileByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserProfileByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class UserProfileListItemModel implements IUserProfileListItemModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    userName?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;

    constructor(data?: IUserProfileListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionName = _data["jurisdictionName"];
            this.title = _data["title"];
            this.organization = _data["organization"];
            this.userName = _data["userName"];
            this.department = _data["department"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.otherPhoneNumberType = _data["otherPhoneNumberType"];
        }
    }

    static fromJS(data: any): UserProfileListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionName"] = this.jurisdictionName;
        data["title"] = this.title;
        data["organization"] = this.organization;
        data["userName"] = this.userName;
        data["department"] = this.department;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["otherPhoneNumberType"] = this.otherPhoneNumberType;
        return data; 
    }

    clone(): UserProfileListItemModel {
        const json = this.toJSON();
        let result = new UserProfileListItemModel();
        result.init(json);
        return result;
    }
}

export interface IUserProfileListItemModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    jurisdictionId?: string | undefined;
    jurisdictionName?: string | undefined;
    title?: string | undefined;
    organization?: string | undefined;
    userName?: string | undefined;
    department?: string | undefined;
    otherPhoneNumber?: string | undefined;
    otherPhoneNumberType?: string | undefined;
}

export class GetAllUserProfileByFilterQueryResponse implements IGetAllUserProfileByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: UserProfileListItemModel[] | undefined;
    count?: number;

    constructor(data?: IGetAllUserProfileByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new UserProfileListItemModel(item) : <UserProfileListItemModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserProfileListItemModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllUserProfileByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserProfileByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetAllUserProfileByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllUserProfileByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserProfileByFilterQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IUserProfileListItemModel[] | undefined;
    count?: number;
}

export enum Operations {
    Create_Role = "Create Role",
    Is_Authenticated = "Is Authenticated",
    View_Roles = "View Roles",
    Activate_User = "Activate User",
    Deactivate_User = "Deactivate User",
    View_User = "View User",
    Edit_Role = "Edit Role",
    Edit_User = "Edit User",
    Add_User = "Add User",
    View_Audit = "View Audit",
    Create_Knowledge_Categories = "Create Knowledge Categories",
    View_Knowledge_Categories = "View Knowledge Categories",
    Edit_Knowledge_Categories = "Edit Knowledge Categories",
    View_Knowledge = "View Knowledge",
    Create_Knowledge = "Create Knowledge",
    Edit_Knowledge = "Edit Knowledge",
    Edit_Access_Level_Public = "Edit Access Level Public",
    Create_Access_Level_Public = "Create Access Level Public",
    View_Access_Level_1 = "View Access Level 1",
    Edit_Access_Level_1 = "Edit Access Level 1",
    Share_Access_Level_1 = "Share Access Level 1",
    Create_Access_Level_1 = "Create Access Level 1",
    Download_Access_Level_1 = "Download Access Level 1",
    View_Access_Level_2 = "View Access Level 2",
    Share_Access_Level_2 = "Share Access Level 2",
    Edit_Access_Level_2 = "Edit Access Level 2",
    Create_Access_Level_2 = "Create Access Level 2",
    Download_Access_Level_2 = "Download Access Level 2",
    View_Access_Level_3 = "View Access Level 3",
    Share_Access_Level_3 = "Share Access Level 3",
    Edit_Access_Level_3 = "Edit Access Level 3",
    Create_Access_Level_3 = "Create Access Level 3",
    Download_Access_Level_3 = "Download Access Level 3",
    View_Access_Level_4 = "View Access Level 4",
    Share_Access_Level_4 = "Share Access Level 4",
    Edit_Access_Level_4 = "Edit Access Level 4",
    Create_Access_Level_4 = "Create Access Level 4",
    Download_Access_Level_4 = "Download Access Level 4",
    View_Access_Level_5 = "View Access Level 5",
    Share_Access_Level_5 = "Share Access Level 5",
    Edit_Access_Level_5 = "Edit Access Level 5",
    Create_Access_Level_5 = "Create Access Level 5",
    Download_Access_Level_5 = "Download Access Level 5",
    View_Knowledge_Template = "View Knowledge Template",
    Create_Knowledge_Data_Template = "Create Knowledge Data Template",
    Edit_Knowledge_Data_Template = "Edit Knowledge Data Template",
    Delete_Knowledge_Data_Template = "Delete Knowledge Data Template",
    Remove_Role = "Remove Role",
    Remove_User = "Remove User",
    Index_New_Knowledge = "Index New Knowledge",
    Generate_User_Reports = "Generate User Reports",
    Generate_Knowledge_Summary_Reports = "Generate Knowledge Summary Reports",
    Generate_Knowledge_Storage_Reports = "Generate Knowledge Storage Reports",
    Generate_User_Login_Reports = "Generate User Login Reports",
    Generate_Knowledge_Contributor_Reports = "Generate Knowledge Contributor Reports",
    Publish_Knowledge = "Publish Knowledge",
    Unpublish_Knowledge = "Unpublish Knowledge",
    View_Unpublish_Knowledge = "View Unpublish Knowledge",
    Delete_Own_Knowledge = "Delete Own Knowledge",
    Delete_Others_Knowledge = "Delete Others Knowledge",
    View_Shared_Knowledge = "View Shared Knowledge",
    Add_Edit_Jurisdiction = "Add Edit Jurisdiction",
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}